const cropData = [
  {
    "name": "RICE",
    "category": "GRAIN",
    "pest": "YELLOW STEM BORER, BROWN PLANT HOPPER, GREEN LEAF HOPPER, LEAF FOLDER, GUNDHI BUG",
    "on": "6:30 PM",
    "off": "10:30 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "WB, UP, PUNJAB, AP, TN",
    "details": "SCIRPOPHAGA INCERTULAS (YSB) ACTIVITY PEAKS 1-2 HRS POST-SUNSET. CNAPHALOCROCIS MEDINALIS (LEAF FOLDER) ALSO HIGHLY PHOTOTACTIC. TRAPS REDUCE OVIPOSITION. AVOID LATE-NIGHT USE TO SAVE PARASITOIDS. ",
    "index": "1",
    "hi": {
      "name": "धान",
      "pest": "पीला तना छेदक, भूरा फुदका, हरा फुदका, पत्ती मोड़क, गंधी बग"
    },
    "gu": {
      "name": "ડાંગર",
      "pest": "પીળો થડ ભેદક, ભૂરો ચૂસિયો, લીલો તડતડિયો, પાન વાળનાર ઈયળ, ગંધી બગ"
    }
  },
  {
    "name": "WHEAT",
    "category": "GRAIN",
    "pest": "PINK STEM BORER, ARMYWORM, TERMITES, APHIDS, GRAM POD BORER",
    "on": "7:00 PM",
    "off": "11:00 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "UP, PUNJAB, HARYANA, MP, RAJASTHAN",
    "details": "SESAMIA INFERENS IS KEY NOCTURNAL BORER. TERMITES SWARM AT DUSK POST-RAIN. HELICOVERPA ATTACKS AT GRAIN STAGE. APHID ALATES TRAPPED IN YELLOW LIGHT. ",
    "index": "2",
    "hi": {
      "name": "गेहूं",
      "pest": "गुलाबी तना छेदक, सैन्य कीट, दीमक, माहू, चना फली छेदक"
    },
    "gu": {
      "name": "ઘઉં",
      "pest": "ગુલાબી થડ ભેદક, લશ્કરી ઈયળ, ઉધઈ, મોલો, ચણા શીંગ ભેદક"
    }
  },
  {
    "name": "MAIZE",
    "category": "GRAIN",
    "pest": "SPOTTED STEM BORER, FALL ARMYWORM, PINK BORER, SHOOT FLY, COB BORER",
    "on": "7:00 PM",
    "off": "11:00 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "KARNATAKA, MP, MAHARASHTRA, BIHAR",
    "details": "CHILO PARTELLUS & SPODOPTERA FRUGIPERDA ARE MAJOR NOCTURNAL THREATS. LIGHT TRAPS ESSENTIAL FOR MONITORING FAW MIGRATION. SHOOT FLY ATTRACTED TO FISH MEAL/LIGHT. ",
    "index": "3",
    "hi": {
      "name": "मक्का",
      "pest": "चित्तीदार तना छेदक, फॉल आर्मीवर्म, गुलाबी छेदक, प्ररोह मक्खी, भुट्टा छेदक"
    },
    "gu": {
      "name": "મકાઈ",
      "pest": "ટપકાંવાળો થડ ભેદક, ફોલ લશ્કરી ઈયળ, ગુલાબી ભેદક, ગાભમારો માખી, ડૂંડા ભેદક"
    }
  },
  {
    "name": "BARLEY",
    "category": "GRAIN",
    "pest": "APHIDS, ARMYWORM, WIREWORMS, THRIPS",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "RAJASTHAN, UP, PUNJAB",
    "details": "RHOPALOSIPHUM APHIDS VECTOR BYDV; ALATES ACTIVE AT DUSK. ARMYWORMS FEED/MATE AT NIGHT. ",
    "index": "4",
    "hi": {
      "name": "जौ",
      "pest": "माहू, सैन्य कीट, वायरवर्म, थ्रिप्स"
    },
    "gu": {
      "name": "જવ",
      "pest": "મોલો, લશ્કરી ઈયળ, વાયરવર્મ, થ્રિપ્સ"
    }
  },
  {
    "name": "OATS",
    "category": "GRAIN",
    "pest": "APHIDS, ARMYWORM, STINK BUGS",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "PUNJAB, HARYANA",
    "details": "SIMILAR PEST COMPLEX TO WHEAT. HELICOVERPA MAY ATTACK PANICLES. ",
    "index": "5",
    "hi": {
      "name": "जई",
      "pest": "माहू, सैन्य कीट, गंध बग"
    },
    "gu": {
      "name": "ઓટ",
      "pest": "મોલો, લશ્કરી ઈયળ, દુર્ગંધ બગ"
    }
  },
  {
    "name": "RYE",
    "category": "GRAIN",
    "pest": "APHIDS, ARMYWORM, STEM BORER",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "HP, NORTHERN PLAINS",
    "details": "ARMYWORMS (MYTHIMNA) ARE NOCTURNAL DEFOLIATORS. PINK STEM BORER MAY INFEST. ",
    "index": "6",
    "hi": {
      "name": "राई",
      "pest": "माहू, सैन्य कीट, तना छेदक"
    },
    "gu": {
      "name": "રાઈ",
      "pest": "મોલો, લશ્કરી ઈયળ, થડ ભેદક"
    }
  },
  {
    "name": "SORGHUM (JOWAR)",
    "category": "GRAIN",
    "pest": "SHOOT FLY, STEM BORER, SORGHUM MIDGE, EARHEAD BUG",
    "on": "6:30 PM",
    "off": "10:30 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "MAHARASHTRA, KARNATAKA, AP, MP",
    "details": "ATHERIGONA SOCCATA (SHOOT FLY) & CHILO PARTELLUS CRITICAL. MIDGE ACTIVE MORNING/EVENING; MOTHS AT NIGHT. ",
    "index": "7",
    "hi": {
      "name": "ज्वार",
      "pest": "प्ररोह मक्खी, तना छेदक, ज्वार मिज, बाली बग"
    },
    "gu": {
      "name": "જુવાર",
      "pest": "ગાભમારો માખી, થડ ભેદક, જુવાર મિજ, ડૂંડા બગ"
    }
  },
  {
    "name": "PEARL MILLET (BAJRA)",
    "category": "GRAIN",
    "pest": "STEM BORER, WHITE GRUB, SHOOT FLY, GREY WEEVIL",
    "on": "7:30 PM",
    "off": "11:30 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "RAJASTHAN, UP, GUJARAT, HARYANA",
    "details": "HOLOTRICHIA BEETLES EMERGE AT DUSK (7:30 PM) POST-RAIN. HIGHLY PHOTOTACTIC. TRAPS CRITICAL DURING MONSOON. ",
    "index": "8",
    "hi": {
      "name": "बाजरा",
      "pest": "तना छेदक, सफेद गिडार, प्ररोह मक्खी, धूसर घुन"
    },
    "gu": {
      "name": "બાજરી",
      "pest": "થડ ભેદક, ધૈણ, ગાભમારો માખી, ભૂખરો ઘૈણ"
    }
  },
  {
    "name": "FINGER MILLET (RAGI)",
    "category": "GRAIN",
    "pest": "PINK STEM BORER, WHITE BORER, CUTWORMS, LEAF FOLDER",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "KARNATAKA, TN, UTTARAKHAND",
    "details": "SESAMIA INFERENS CAUSES DEAD HEARTS. CUTWORMS ACTIVE AT NIGHT. ",
    "index": "9",
    "hi": {
      "name": "रागी",
      "pest": "गुलाबी तना छेदक, सफेद छेदक, कटवर्म, पत्ती मोड़क"
    },
    "gu": {
      "name": "રાગી",
      "pest": "ગુલાબી થડ ભેદક, સફેદ ભેદક, કાતરા, પાન વાળનાર ઈયળ"
    }
  },
  {
    "name": "FOXTAIL MILLET",
    "category": "GRAIN",
    "pest": "SHOOT FLY, STEM BORER, APHIDS",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "AP, KARNATAKA",
    "details": "ATHERIGONA SHOOT FLY CAUSES SEEDLING MORTALITY. ",
    "index": "10",
    "hi": {
      "name": "कंगनी",
      "pest": "प्ररोह मक्खी, तना छेदक, माहू"
    },
    "gu": {
      "name": "કાંગ",
      "pest": "ગાભમારો માખી, થડ ભેદક, મોલો"
    }
  },
  {
    "name": "LITTLE MILLET",
    "category": "GRAIN",
    "pest": "SHOOT FLY, STEM BORER",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "MP, CHHATTISGARH",
    "details": "MINOR PESTS INCLUDE SHOOT FLY. LIGHT TRAPS AID SURVEILLANCE. ",
    "index": "11",
    "hi": {
      "name": "कुटकी",
      "pest": "प्ररोह मक्खी, तना छेदक"
    },
    "gu": {
      "name": "કુટકી",
      "pest": "ગાભમારો માખી, થડ ભેદક"
    }
  },
  {
    "name": "BARNYARD MILLET",
    "category": "GRAIN",
    "pest": "STEM BORER, CUTWORMS",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "UTTARAKHAND, TN",
    "details": "SUSCEPTIBLE TO GENERALIST GRAMINACEOUS BORERS. ",
    "index": "12",
    "hi": {
      "name": "सांवा",
      "pest": "तना छेदक, कटवर्म"
    },
    "gu": {
      "name": "સામો",
      "pest": "થડ ભેદક, કાતરા"
    }
  },
  {
    "name": "KODO MILLET",
    "category": "GRAIN",
    "pest": "SHOOT FLY, STEM BORER",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "MP, TN",
    "details": "ATHERIGONA SPECIES ARE PRIMARY PESTS. ",
    "index": "13",
    "hi": {
      "name": "कोदो",
      "pest": "प्ररोह मक्खी, तना छेदक"
    },
    "gu": {
      "name": "કોદરા",
      "pest": "ગાભમારો માખી, થડ ભેદક"
    }
  },
  {
    "name": "PROSO MILLET",
    "category": "GRAIN",
    "pest": "SHOOT FLY, STEM BORER, APHIDS",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "TN, KARNATAKA",
    "details": "GENERAL MILLET PEST COMPLEX. ",
    "index": "14",
    "hi": {
      "name": "चीना",
      "pest": "प्ररोह मक्खी, तना छेदक, माहू"
    },
    "gu": {
      "name": "ચીનો",
      "pest": "ગાભમારો માખી, થડ ભેદક, મોલો"
    }
  },
  {
    "name": "BUCKWHEAT (KUTTU)",
    "category": "GRAIN",
    "pest": "APHIDS, WIREWORMS, CUTWORMS",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "HIMALAYAN REGION, NORTH EAST",
    "details": "AGROTIS CUTWORMS DAMAGE SEEDLINGS AT NIGHT. ",
    "index": "15",
    "hi": {
      "name": "कुट्टू",
      "pest": "माहू, वायरवर्म, कटवर्म"
    },
    "gu": {
      "name": "કૂટુ",
      "pest": "મોલો, વાયરવર્મ, કાતરા"
    }
  },
  {
    "name": "QUINOA",
    "category": "GRAIN",
    "pest": "APHIDS, STEM BORER, ARMYWORM, CUTWORMS, LEAF MINER",
    "on": "6:30 PM",
    "off": "10:30 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "AP, UTTARAKHAND, RAJASTHAN",
    "details": "SPODOPTERA & HELICOVERPA ARE MAJOR THREATS. STEM BORERS (COSMOBARIS) REPORTED. ",
    "index": "16",
    "hi": {
      "name": "क्विनोआ",
      "pest": "माहू, तना छेदक, सैन्य कीट, कटवर्म, पत्ती सुरंगक"
    },
    "gu": {
      "name": "ક્વિનોઆ",
      "pest": "મોલો, થડ ભેદક, લશ્કરી ઈયળ, કાતરા, પાન કોરિયું"
    }
  },
  {
    "name": "AMARANTH GRAIN (RAJGIRA)",
    "category": "GRAIN",
    "pest": "STEM WEEVIL, LEAF WEBBER, CATERPILLARS",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "",
    "details": "",
    "index": "17",
    "hi": {
      "name": "राजगिरा",
      "pest": "तना घुन, पत्ती जालक, इल्लियाँ"
    },
    "gu": {
      "name": "રાજગરો",
      "pest": "થડ ઘૈણ, પાન જાળિયું, ઈયળો"
    }
  },
  {
    "name": "CHICKPEA (GRAM)",
    "category": "PULSE",
    "pest": "GRAM POD BORER, CUTWORM, APHIDS, SEMILOOPER",
    "on": "6:30 PM",
    "off": "10:30 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "MP, RAJASTHAN, MAHARASHTRA, UP",
    "details": "HELICOVERPA ARMIGERA IS THE KEY PEST; PEAK MOTH ACTIVITY 7-10 PM. AGROTIS IPSILON CUTS SEEDLINGS AT NIGHT. ",
    "index": "18",
    "hi": {
      "name": "चना",
      "pest": "चना फली छेदक, कटवर्म, माहू, सेमीलूपर"
    },
    "gu": {
      "name": "ચણા",
      "pest": "ચણા શીંગ ભેદક, કાતરા, મોલો, સેમિલૂપર"
    }
  },
  {
    "name": "PIGEON PEA (TUR/ARHAR)",
    "category": "PULSE",
    "pest": "POD BORER, PLUME MOTH, POD FLY, SPOTTED POD BORER, BLISTER BEETLE",
    "on": "6:45 PM",
    "off": "10:45 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "MAHARASHTRA, KARNATAKA, MP, UP",
    "details": "HELICOVERPA & MARUCA VITRATA CAUSE HEAVY DAMAGE. MARUCA ACTIVE AT NIGHT. BLISTER BEETLES ACTIVE DAY/DUSK. ",
    "index": "19",
    "hi": {
      "name": "अरहर",
      "pest": "फली छेदक, प्लूम पतंगा, फली मक्खी, चित्तीदार फली छेदक, फफोला भृंग"
    },
    "gu": {
      "name": "તુવેર",
      "pest": "શીંગ ભેદક, પ્લૂમ પતંગિયું, શીંગ માખી, ટપકાંવાળી શીંગ ભેદક, ફોલ્લા ભમરો"
    }
  },
  {
    "name": "GREEN GRAM (MOONG)",
    "category": "PULSE",
    "pest": "WHITEFLY, THRIPS, POD BORER, STEM FLY, APHIDS",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "RAJASTHAN, MAHARASHTRA, AP",
    "details": "SUCKING PESTS (WHITEFLY, THRIPS) TRANSMIT YMV. YELLOW/WARM LIGHT TRAPS EFFECTIVE. BORERS ACTIVE AT NIGHT. ",
    "index": "20",
    "hi": {
      "name": "मूंग",
      "pest": "सफेद मक्खी, थ्रिप्स, फली छेदक, तना मक्खी, माहू"
    },
    "gu": {
      "name": "મગ",
      "pest": "સફેદમાખી, થ્રિપ્સ, શીંગ ભેદક, થડ માખી, મોલો"
    }
  },
  {
    "name": "BLACK GRAM (URAD)",
    "category": "PULSE",
    "pest": "WHITEFLY, POD BORER, STEM FLY, LEAF FOLDER, HAIRY CATERPILLAR",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "AP, MAHARASHTRA, MP",
    "details": "SPILOSOMA OBLIQUA (BIHAR HAIRY CATERPILLAR) MOTHS ATTRACTED TO LIGHT. WHITEFLY CONTROL CRUCIAL. ",
    "index": "21",
    "hi": {
      "name": "उड़द",
      "pest": "सफेद मक्खी, फली छेदक, तना मक्खी, पत्ती मोड़क, रोमिल इल्ली"
    },
    "gu": {
      "name": "અડદ",
      "pest": "સફેદમાખી, શીંગ ભેદક, થડ માખી, પાન વાળનાર ઈયળ, રુવાંટીવાળી ઈયળ"
    }
  },
  {
    "name": "LENTIL (MASUR)",
    "category": "PULSE",
    "pest": "APHIDS, POD BORER, CUTWORM, WEEVILS",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "UP, MP, BIHAR",
    "details": "APHIDS & HELICOVERPA MAJOR. CUTWORMS DAMAGE SEEDLINGS. LIGHT TRAPS MONITOR MOTH FLIGHTS. ",
    "index": "22",
    "hi": {
      "name": "मसूर",
      "pest": "माहू, फली छेदक, कटवर्म, घुन"
    },
    "gu": {
      "name": "મસૂર",
      "pest": "મોલો, શીંગ ભેદક, કાતરા, ઘૈણ"
    }
  },
  {
    "name": "FIELD PEA",
    "category": "PULSE",
    "pest": "POD BORER, PEA APHID, LEAF MINER, STEM FLY",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "UP, MP",
    "details": "HELICOVERPA & ETIELLA ZINCKENELLA (LIMA BEAN POD BORER) KEY. ",
    "index": "23",
    "hi": {
      "name": "मटर",
      "pest": "फली छेदक, मटर माहू, पत्ती सुरंगक, तना मक्खी"
    },
    "gu": {
      "name": "વટાણા",
      "pest": "શીંગ ભેદક, વટાણા મોલો, પાન કોરિયું, થડ માખી"
    }
  },
  {
    "name": "COWPEA",
    "category": "PULSE",
    "pest": "APHIDS, POD BORER, SPOTTED POD BORER, LEAF HOPPER",
    "on": "6:30 PM",
    "off": "10:30 PM",
    "duration": "4:00",
    "light": "WARM",
    "region": "KARNATAKA, TN, AP",
    "details": "MARUCA VITRATA & HELICOVERPA TARGET PODS. APHIS CRACCIVORA VECTORS VIRUS. ",
    "index": "24",
    "hi": {
      "name": "लोबिया",
      "pest": "माहू, फली छेदक, चित्तीदार फली छेदक, पत्ती फुदका"
    },
    "gu": {
      "name": "ચોળા",
      "pest": "મોલો, શીંગ ભેદક, ટપકાંવાળી શીંગ ભેદક, પાન તડતડિયો"
    }
  },
  {
    "name": "HORSE GRAM",
    "category": "PULSE",
    "pest": "POD BORER, LEAF WEBBER, APHIDS, STEM FLY",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "KARNATAKA, TN, AP",
    "details": "ATTACKED BY ETIELLA ZINCKENELLA & SPODOPTERA. ",
    "index": "25",
    "hi": {
      "name": "कुल्थी",
      "pest": "फली छेदक, पत्ती जालक, माहू, तना मक्खी"
    },
    "gu": {
      "name": "કળથી",
      "pest": "શીંગ ભેદક, પાન જાળિયું, મોલો, થડ માખી"
    }
  },
  {
    "name": "MOTH BEAN",
    "category": "PULSE",
    "pest": "WHITEFLY, JASSIDS, POD BORER, YMV VECTORS",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "RAJASTHAN, MAHARASHTRA",
    "details": "SUCKING PESTS PRIMARY. BEMISIA TABACI ATTRACTED TO YELLOW SPECTRUM. ",
    "index": "26",
    "hi": {
      "name": "मोठ",
      "pest": "सफेद मक्खी, हरा तेला, फली छेदक, वाईएमवी वाहक"
    },
    "gu": {
      "name": "મઠ",
      "pest": "સફેદમાખી, તડતડિયાં, શીંગ ભેદક, વાયએમવી વાહક"
    }
  },
  {
    "name": "BROAD BEAN",
    "category": "PULSE",
    "pest": "APHIDS, POD BORER, LEAF MINER",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "NORTH EAST, BIHAR",
    "details": "APHIS FABAE IS SEVERE. POD BORERS ATTACK SEEDS. ",
    "index": "27",
    "hi": {
      "name": "बाकला",
      "pest": "माहू, फली छेदक, पत्ती सुरंगक"
    },
    "gu": {
      "name": "વાલ",
      "pest": "મોલો, શીંગ ભેદક, પાન કોરિયું"
    }
  },
  {
    "name": "KIDNEY BEAN (RAJMA)",
    "category": "PULSE",
    "pest": "POD BORER, APHIDS, BEAN FLY, STEM FLY",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "MAHARASHTRA, HP, J&K",
    "details": "HELICOVERPA & MARUCA INFEST PODS. STEM FLY MINES STEMS. ",
    "index": "28",
    "hi": {
      "name": "राजमा",
      "pest": "फली छेदक, माहू, बीन मक्खी, तना मक्खी"
    },
    "gu": {
      "name": "રાજમા",
      "pest": "શીંગ ભેદક, મોલો, બીન માખી, થડ માખી"
    }
  },
  {
    "name": "RICE BEAN",
    "category": "PULSE",
    "pest": "APHIDS, POD BORER, BLISTER BEETLE",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "NORTH EAST, ODISHA",
    "details": "MINOR PULSE; PESTS SIMILAR TO GREEN GRAM. ",
    "index": "29",
    "hi": {
      "name": "राइस बीन",
      "pest": "माहू, फली छेदक, फफोला भृंग"
    },
    "gu": {
      "name": "રાઇસ બીન",
      "pest": "મોલો, શીંગ ભેદક, ફોલ્લા ભમરો"
    }
  },
  {
    "name": "LABLAB BEAN",
    "category": "PULSE",
    "pest": "POD BORER, APHIDS, POD BUGS, BLUE BUTTERFLY",
    "on": "6:30 PM",
    "off": "10:30 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "KARNATAKA, TN, AP",
    "details": "ADISURA ATKINSONI IS SPECIFIC POD BORER. MARUCA ALSO PREVALENT. ",
    "index": "30",
    "hi": {
      "name": "सेम",
      "pest": "फली छेदक, माहू, फली बग, नीली तितली"
    },
    "gu": {
      "name": "વાલોળ",
      "pest": "શીંગ ભેદક, મોલો, શીંગ બગ, ભૂરું પતંગિયું"
    }
  },
  {
    "name": "SOYBEAN",
    "category": "PULSE",
    "pest": "GIRDLE BEETLE, STEM FLY, TOBACCO CATERPILLAR, GREEN SEMILOOPER",
    "on": "7:00 PM",
    "off": "11:00 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "MP, MAHARASHTRA, RAJASTHAN",
    "details": "SPODOPTERA LITURA VORACIOUS DEFOLIATOR; MOTHS HIGHLY PHOTOTACTIC. OBEREOPSIS BREVIS & STEM FLY MAJOR. ",
    "index": "31",
    "hi": {
      "name": "सोयाबीन",
      "pest": "गर्डल भृंग, तना मक्खी, तंबाकू इल्ली, हरा सेमीलूपर"
    },
    "gu": {
      "name": "સોયાબીન",
      "pest": "ગર્ડલ ભમરો, થડ માખી, તમાકુ ઈયળ, લીલો સેમિલૂપર"
    }
  },
  {
    "name": "CLUSTER BEAN (GUAR)",
    "category": "PULSE",
    "pest": "APHIDS, JASSIDS, WHITEFLY, POD BORER",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "RAJASTHAN, HARYANA, GUJARAT",
    "details": "SUCKING PESTS DOMINATE. BEMISIA & EMPOASCA SPECIES. YELLOW TRAPS RECOMMENDED. ",
    "index": "32",
    "hi": {
      "name": "ग्वार",
      "pest": "माहू, हरा तेला, सफेद मक्खी, फली छेदक"
    },
    "gu": {
      "name": "ગુવાર",
      "pest": "મોલો, તડતડિયાં, સફેદમાખી, શીંગ ભેદક"
    }
  },
  {
    "name": "GROUNDNUT",
    "category": "OILSEED",
    "pest": "RED HAIRY CATERPILLAR, LEAF MINER, WHITE GRUB, TOBACCO CATERPILLAR, APHIDS",
    "on": "7:00 PM",
    "off": "11:00 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "GUJARAT, AP, TN, KARNATAKA",
    "details": "AMSACTA (RHC) EMERGES POST-RAIN; LIGHT TRAPS CRITICAL. APPROAEREMA MODICELLA (LEAF MINER) ATTRACTED TO LIGHT. ",
    "index": "33",
    "hi": {
      "name": "मूंगफली",
      "pest": "लाल रोमिल इल्ली, पत्ती सुरंगक, सफेद गिडार, तंबाकू इल्ली, माहू"
    },
    "gu": {
      "name": "મગફળી",
      "pest": "લાલ રુવાંટીવાળી ઈયળ, પાન કોરિયું, ધૈણ, તમાકુ ઈયળ, મોલો"
    }
  },
  {
    "name": "MUSTARD",
    "category": "OILSEED",
    "pest": "APHIDS, SAWFLY, PAINTED BUG, DIAMONDBACK MOTH",
    "on": "5:30 PM",
    "off": "9:00 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "RAJASTHAN, HARYANA, MP, UP",
    "details": "LIPAPHIS ERYSIMI KEY; ALATES ATTRACTED TO YELLOW/WARM LIGHT. ATHALIA LUGENS (SAWFLY) LARVAE DEFOLIATE. ",
    "index": "34",
    "hi": {
      "name": "सरसों",
      "pest": "माहू, आरा मक्खी, चित्रित बग, डायमंडबैक पतंगा"
    },
    "gu": {
      "name": "સરસવ",
      "pest": "મોલો, કરવત માખી, ચિતરેલ બગ, હીરાફૂદું"
    }
  },
  {
    "name": "RAPESEED",
    "category": "OILSEED",
    "pest": "APHIDS, PAINTED BUG, SAWFLY",
    "on": "5:30 PM",
    "off": "9:00 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "RAJASTHAN, HARYANA",
    "details": "SIMILAR TO MUSTARD. APHID MANAGEMENT PRIORITY. ",
    "index": "35",
    "hi": {
      "name": "तोरिया",
      "pest": "माहू, चित्रित बग, आरा मक्खी"
    },
    "gu": {
      "name": "તોરિયા",
      "pest": "મોલો, ચિતરેલ બગ, કરવત માખી"
    }
  },
  {
    "name": "SOYBEAN",
    "category": "OILSEED",
    "pest": "TOBACCO CATERPILLAR, GIRDLE BEETLE, SEMILOOPER, STEM FLY",
    "on": "7:00 PM",
    "off": "11:00 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "MP, MAHARASHTRA",
    "details": "SPODOPTERA LITURA CAUSES EXTENSIVE DEFOLIATION. CHRYSODEIXIS ACUTA (GREEN SEMILOOPER) MOTHS ATTRACTED TO LIGHT. ",
    "index": "36",
    "hi": {
      "name": "सोयाबीन",
      "pest": "तंबाकू इल्ली, गर्डल भृंग, सेमीलूपर, तना मक्खी"
    },
    "gu": {
      "name": "સોયાબીન",
      "pest": "તમાકુ ઈયળ, ગર્ડલ ભમરો, સેમિલૂપર, થડ માખી"
    }
  },
  {
    "name": "SUNFLOWER",
    "category": "OILSEED",
    "pest": "HEAD BORER, TOBACCO CATERPILLAR, BIHAR HAIRY CATERPILLAR, JASSIDS",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "KARNATAKA, MAHARASHTRA, AP",
    "details": "HELICOVERPA ARMIGERA FEEDS ON SEEDS IN HEAD. SPILOSOMA OBLIQUA DEFOLIATES. ",
    "index": "37",
    "hi": {
      "name": "सूरजमुखी",
      "pest": "शीर्ष छेदक, तंबाकू इल्ली, बिहार रोमिल इल्ली, हरा तेला"
    },
    "gu": {
      "name": "સૂરજમુખી",
      "pest": "ડૂંડા ભેદક, તમાકુ ઈયળ, બિહાર રુવાંટીવાળી ઈયળ, તડતડિયાં"
    }
  },
  {
    "name": "SESAME (TIL)",
    "category": "OILSEED",
    "pest": "LEAF WEBBER/CAPSULE BORER, GALL FLY, SPHINX MOTH",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "WB, MP, RAJASTHAN",
    "details": "ANTIGASTRA CATALAUNALIS (SHOOT/CAPSULE BORER) MAJOR. ACHERONTIA STYX (TIL HAWK MOTH) LARGE, NOCTURNAL. ",
    "index": "38",
    "hi": {
      "name": "तिल",
      "pest": "पत्ती जालक/कैप्सूल छेदक, गॉल मक्खी, स्फिंक्स पतंगा"
    },
    "gu": {
      "name": "તલ",
      "pest": "પાન જાળિયું/બોંડ ભેદક, ગોલ માખી, સ્ફિન્ક્સ પતંગિયું"
    }
  },
  {
    "name": "SAFFLOWER",
    "category": "OILSEED",
    "pest": "APHIDS, CAPSULE BORER, FRUIT FLY",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "MAHARASHTRA, KARNATAKA",
    "details": "UROLEUCON COMPOSITAE (SAFFLOWER APHID) SUCKS SAP. HELICOVERPA BORES CAPSULES. ",
    "index": "39",
    "hi": {
      "name": "कुसुम",
      "pest": "माहू, कैप्सूल छेदक, फल मक्खी"
    },
    "gu": {
      "name": "કસુંબી",
      "pest": "મોલો, બોંડ ભેદક, ફળ માખી"
    }
  },
  {
    "name": "NIGER SEED",
    "category": "OILSEED",
    "pest": "NIGER CATERPILLAR, SEMILOOPER",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "MP, ODISHA, CHHATTISGARH",
    "details": "CONDICA CAPENSIS AND DEFOLIATORS. MOTHS PHOTOTACTIC. ",
    "index": "40",
    "hi": {
      "name": "रामतिल",
      "pest": "रामतिल इल्ली, सेमीलूपर"
    },
    "gu": {
      "name": "રામતલ",
      "pest": "રામતલ ઈયળ, સેમિલૂપર"
    }
  },
  {
    "name": "CASTOR",
    "category": "OILSEED",
    "pest": "SEMILOOPER, CAPSULE BORER, SHOOT BORER, TOBACCO CATERPILLAR",
    "on": "7:00 PM",
    "off": "11:00 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "GUJARAT, RAJASTHAN, AP",
    "details": "ACHAEA JANATA (SEMILOOPER) & DICHOCROCIS PUNCTIFERALIS (CAPSULE BORER) MAJOR. NOCTURNAL MOTHS. ",
    "index": "41",
    "hi": {
      "name": "अरंडी",
      "pest": "सेमीलूपर, कैप्सूल छेदक, प्ररोह छेदक, तंबाकू इल्ली"
    },
    "gu": {
      "name": "એરંડા",
      "pest": "સેમિલૂપર, બોંડ ભેદક, ડૂંખ ભેદક, તમાકુ ઈયળ"
    }
  },
  {
    "name": "LINSEED (FLAX)",
    "category": "OILSEED",
    "pest": "BUD FLY, CAPSULE BORER, SEMILOOPER",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "MP, UP, BIHAR",
    "details": "DASYNEURA LINI (BUD FLY) SPECIFIC PEST. HELICOVERPA ATTACKS CAPSULES. ",
    "index": "42",
    "hi": {
      "name": "अलसी",
      "pest": "कली मक्खी, कैप्सूल छेदक, सेमीलूपर"
    },
    "gu": {
      "name": "અળસી",
      "pest": "કળી માખી, બોંડ ભેદક, સેમિલૂપર"
    }
  },
  {
    "name": "CAMELINA",
    "category": "OILSEED",
    "pest": "APHIDS, DIAMONDBACK MOTH",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "NORTHERN INDIA",
    "details": "EMERGING CROP. APHIDS/DBM POTENTIAL PESTS. ",
    "index": "43",
    "hi": {
      "name": "कैमेलिना",
      "pest": "माहू, डायमंडबैक पतंगा"
    },
    "gu": {
      "name": "કેમેલિના",
      "pest": "મોલો, હીરાફૂદું"
    }
  },
  {
    "name": "POPPY SEED",
    "category": "OILSEED",
    "pest": "CAPSULE BORER, ROOT WEEVIL, APHIDS",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "MP, RAJASTHAN, UP",
    "details": "HELICOVERPA BORES CAPSULES. APHIDS SUCK SAP. ",
    "index": "44",
    "hi": {
      "name": "खसखस",
      "pest": "कैप्सूल छेदक, जड़ घुन, माहू"
    },
    "gu": {
      "name": "ખસખસ",
      "pest": "બોંડ ભેદક, મૂળ ઘૈણ, મોલો"
    }
  },
  {
    "name": "OIL PALM",
    "category": "OILSEED",
    "pest": "RHINOCEROS BEETLE, BAGWORMS, NETTLE CATERPILLARS",
    "on": "6:30 PM",
    "off": "10:30 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "AP, KARNATAKA, TN",
    "details": "ORYCTES RHINOCEROS MAJOR; ADULTS ATTRACTED TO LIGHT/PHEROMONE. BAGWORMS DAMAGE FRONDS. ",
    "index": "45",
    "hi": {
      "name": "तेल ताड़",
      "pest": "गैंडा भृंग, थैली कीट, नेटल इल्ली"
    },
    "gu": {
      "name": "તેલ તાડ",
      "pest": "ગેંડા ભમરો, થેલી ઈયળ, નેટલ ઈયળ"
    }
  },
  {
    "name": "POTATO",
    "category": "VEGETABLE",
    "pest": "CUTWORM, POTATO TUBER MOTH, APHIDS, WHITE GRUB",
    "on": "7:00 PM",
    "off": "11:00 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "UP, WB, PUNJAB, GUJARAT",
    "details": "PHTHORIMAEA OPERCULELLA (PTM) NOCTURNAL. AGROTIS CUTWORMS FEED NIGHT. ",
    "index": "46",
    "hi": {
      "name": "आलू",
      "pest": "कटवर्म, आलू कंद पतंगा, माहू, सफेद गिडार"
    },
    "gu": {
      "name": "બટાટા",
      "pest": "કાતરા, બટાટા કંદ પતંગિયું, મોલો, ધૈણ"
    }
  },
  {
    "name": "SWEET POTATO",
    "category": "VEGETABLE",
    "pest": "SWEET POTATO WEEVIL, VINE BORER",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "ODISHA, UP, WB",
    "details": "CYLAS FORMICARIUS WEEVIL ADULTS NOCTURNAL/PHOTOTACTIC. ",
    "index": "47",
    "hi": {
      "name": "शकरकंद",
      "pest": "शकरकंद घुन, बेल छेदक"
    },
    "gu": {
      "name": "શક્કરિયાં",
      "pest": "શક્કરિયાં ઘૈણ, વેલ ભેદક"
    }
  },
  {
    "name": "YAM",
    "category": "VEGETABLE",
    "pest": "YAM SCALE, HAIRY CATERPILLAR, YAM BEETLE",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "KERALA, ODISHA, NE INDIA",
    "details": "SCALE INSECTS & DEFOLIATING CATERPILLARS. ",
    "index": "48",
    "hi": {
      "name": "रतालू",
      "pest": "रतालू स्केल, रोमिल इल्ली, रतालू भृंग"
    },
    "gu": {
      "name": "રતાળુ",
      "pest": "સૂરણ ચીકટો, રુવાંટીવાળી ઈયળ, સૂરણ ભમરો"
    }
  },
  {
    "name": "CASSAVA (TAPIOCA)",
    "category": "VEGETABLE",
    "pest": "SPIRALING WHITEFLY, MEALYBUG, SCALE INSECT, RED SPIDER MITE",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "KERALA, TN, AP",
    "details": "BEMISIA & ALEURODICUS (SPIRALING WHITEFLY). YELLOW LIGHT TRAPS EFFECTIVE. ",
    "index": "49",
    "hi": {
      "name": "कसावा",
      "pest": "सर्पिल सफेद मक्खी, मिलीबग, स्केल कीट, लाल मकड़ी माइट"
    },
    "gu": {
      "name": "કસાવા",
      "pest": "સર્પાકાર સફેદમાખી, મિલીબગ, ચીકટો, લાલ કરોળિયા કથીરી"
    }
  },
  {
    "name": "ONION",
    "category": "VEGETABLE",
    "pest": "THRIPS, ONION MAGGOT, CUTWORM",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "MAHARASHTRA, KARNATAKA, GUJARAT",
    "details": "THRIPS TABACI SERIOUS; ATTRACTED TO BLUE/YELLOW LIGHT. CUTWORMS NOCTURNAL. ",
    "index": "50",
    "hi": {
      "name": "प्याज",
      "pest": "थ्रिप्स, प्याज मैगट, कटवर्म"
    },
    "gu": {
      "name": "ડુંગળી",
      "pest": "થ્રિપ્સ, ડુંગળી કીડા, કાતરા"
    }
  },
  {
    "name": "GARLIC",
    "category": "VEGETABLE",
    "pest": "THRIPS, MITES, MAGGOTS",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "MP, RAJASTHAN, GUJARAT",
    "details": "THRIPS CAUSE SILVERY PATCHES. ",
    "index": "51",
    "hi": {
      "name": "लहसुन",
      "pest": "थ्रिप्स, माइट, मैगट"
    },
    "gu": {
      "name": "લસણ",
      "pest": "થ્રિપ્સ, કથીરી, કીડા"
    }
  },
  {
    "name": "LEEK",
    "category": "VEGETABLE",
    "pest": "THRIPS, ONION FLY",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "NILGIRIS, HP",
    "details": "THRIPS MAIN CONCERN. ",
    "index": "52",
    "hi": {
      "name": "लीक",
      "pest": "थ्रिप्स, प्याज मक्खी"
    },
    "gu": {
      "name": "લીક",
      "pest": "થ્રિપ્સ, ડુંગળી માખી"
    }
  },
  {
    "name": "SHALLOT",
    "category": "VEGETABLE",
    "pest": "THRIPS, CUTWORM",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "TN, KARNATAKA",
    "details": "THRIPS MANAGEMENT CRUCIAL. ",
    "index": "53",
    "hi": {
      "name": "छोटा प्याज",
      "pest": "थ्रिप्स, कटवर्म"
    },
    "gu": {
      "name": "નાની ડુંગળી",
      "pest": "થ્રિપ્સ, કાતરા"
    }
  },
  {
    "name": "TOMATO",
    "category": "VEGETABLE",
    "pest": "FRUIT BORER, SERPENTINE LEAF MINER, WHITEFLY, PINWORM",
    "on": "6:30 PM",
    "off": "10:30 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "AP, MP, KARNATAKA",
    "details": "HELICOVERPA & TUTA ABSOLUTA (PINWORM) CRITICAL. TUTA MOTHS NOCTURNAL. ",
    "index": "54",
    "hi": {
      "name": "टमाटर",
      "pest": "फल छेदक, सर्पेन्टाइन पत्ती सुरंगक, सफेद मक्खी, पिनवर्म"
    },
    "gu": {
      "name": "ટામેટાં",
      "pest": "ફળ ભેદક, સર્પાકાર પાન કોરિયું, સફેદમાખી, પિનવર્મ"
    }
  },
  {
    "name": "BRINJAL (EGGPLANT)",
    "category": "VEGETABLE",
    "pest": "SHOOT & FRUIT BORER, HADDA BEETLE, STEM BORER, JASSIDS",
    "on": "7:00 PM",
    "off": "11:00 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "WB, ODISHA, GUJARAT, BIHAR",
    "details": "LEUCINODES ORBONALIS MOTHS ACTIVE NIGHT. HENOSEPILACHNA BEETLES FEED ON LEAVES. ",
    "index": "55",
    "hi": {
      "name": "बैंगन",
      "pest": "प्ररोह व फल छेदक, हड्डा भृंग, तना छेदक, हरा तेला"
    },
    "gu": {
      "name": "રીંગણ",
      "pest": "ડૂંખ અને ફળ ભેદક, હડ્ડા ભમરો, થડ ભેદક, તડતડિયાં"
    }
  },
  {
    "name": "CAPSICUM",
    "category": "VEGETABLE",
    "pest": "THRIPS, MITES, APHIDS, FRUIT BORER",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "KARNATAKA, HP",
    "details": "SCIRTOTHRIPS & MITES (LEAF CURL). HELICOVERPA BORES FRUIT. ",
    "index": "56",
    "hi": {
      "name": "शिमला मिर्च",
      "pest": "थ्रिप्स, माइट, माहू, फल छेदक"
    },
    "gu": {
      "name": "કેપ્સિકમ",
      "pest": "થ્રિપ્સ, કથીરી, મોલો, ફળ ભેદક"
    }
  },
  {
    "name": "CHILLI",
    "category": "VEGETABLE",
    "pest": "THRIPS, YELLOW MITE, APHIDS, POD BORER",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "AP, TELANGANA, KARNATAKA",
    "details": "THRIPS/MITES (MURDA COMPLEX) DEVASTATING. BLUE STICKY/LIGHT TRAPS FOR THRIPS. ",
    "index": "57",
    "hi": {
      "name": "मिर्च",
      "pest": "थ्रिप्स, पीला माइट, माहू, फली छेदक"
    },
    "gu": {
      "name": "મરચાં",
      "pest": "થ્રિપ્સ, પીળી કથીરી, મોલો, શીંગ ભેદક"
    }
  },
  {
    "name": "CABBAGE",
    "category": "VEGETABLE",
    "pest": "DIAMONDBACK MOTH, CABBAGE BUTTERFLY, APHIDS, LEAF WEBBER",
    "on": "6:30 PM",
    "off": "10:30 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "WB, ODISHA, GUJARAT",
    "details": "PLUTELLA XYLOSTELLA (DBM) RESISTANT; MOTHS LIGHT-ATTRACTED. PIERIS BUTTERFLY DIURNAL. ",
    "index": "58",
    "hi": {
      "name": "पत्ता गोभी",
      "pest": "डायमंडबैक पतंगा, गोभी तितली, माहू, पत्ती जालक"
    },
    "gu": {
      "name": "કોબીજ",
      "pest": "હીરાફૂદું, કોબીજ પતંગિયું, મોલો, પાન જાળિયું"
    }
  },
  {
    "name": "CAULIFLOWER",
    "category": "VEGETABLE",
    "pest": "DIAMONDBACK MOTH, APHIDS, TOBACCO CATERPILLAR",
    "on": "6:30 PM",
    "off": "10:30 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "BIHAR, UP, WB",
    "details": "DBM & SPODOPTERA NOCTURNAL THREATS. ",
    "index": "59",
    "hi": {
      "name": "फूल गोभी",
      "pest": "डायमंडबैक पतंगा, माहू, तंबाकू इल्ली"
    },
    "gu": {
      "name": "ફૂલકોબી",
      "pest": "હીરાફૂદું, મોલો, તમાકુ ઈયળ"
    }
  },
  {
    "name": "BROCCOLI",
    "category": "VEGETABLE",
    "pest": "DIAMONDBACK MOTH, APHIDS, CABBAGE LOOPER",
    "on": "6:30 PM",
    "off": "10:30 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "HP, UTTARAKHAND",
    "details": "DBM PRIMARY PEST. ",
    "index": "60",
    "hi": {
      "name": "ब्रोकली",
      "pest": "डायमंडबैक पतंगा, माहू, गोभी लूपर"
    },
    "gu": {
      "name": "બ્રોકોલી",
      "pest": "હીરાફૂદું, મોલો, કોબીજ લૂપર"
    }
  },
  {
    "name": "KOHLRABI",
    "category": "VEGETABLE",
    "pest": "DBM, APHIDS",
    "on": "6:30 PM",
    "off": "10:30 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "KASHMIR, WB",
    "details": "CRUCIFEROUS PEST COMPLEX. ",
    "index": "61",
    "hi": {
      "name": "गांठ गोभी",
      "pest": "डायमंडबैक पतंगा, माहू"
    },
    "gu": {
      "name": "ગાંઠકોબી",
      "pest": "હીરાફૂદું, મોલો"
    }
  },
  {
    "name": "OKRA",
    "category": "VEGETABLE",
    "pest": "SHOOT & FRUIT BORER, JASSIDS, WHITEFLY, BLISTER BEETLE",
    "on": "7:00 PM",
    "off": "11:00 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "WB, BIHAR, GUJARAT, AP",
    "details": "EARIAS VITTELLA MOTHS NOCTURNAL. JASSIDS CAUSE HOPPER BURN. ",
    "index": "62",
    "hi": {
      "name": "भिंडी",
      "pest": "प्ररोह व फल छेदक, हरा तेला, सफेद मक्खी, फफोला भृंग"
    },
    "gu": {
      "name": "ભીંડા",
      "pest": "ડૂંખ અને ફળ ભેદક, તડતડિયાં, સફેદમાખી, ફોલ્લા ભમરો"
    }
  },
  {
    "name": "SPINACH",
    "category": "VEGETABLE",
    "pest": "APHIDS, LEAF EATING CATERPILLAR",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "UP, AP",
    "details": "SPODOPTERA LARVAE DEFOLIATE. APHIDS CURL LEAVES. ",
    "index": "63",
    "hi": {
      "name": "पालक",
      "pest": "माहू, पत्ती खाने वाली इल्ली"
    },
    "gu": {
      "name": "પાલક",
      "pest": "મોલો, પાન ખાનાર ઈયળ"
    }
  },
  {
    "name": "FENUGREEK LEAVES",
    "category": "VEGETABLE",
    "pest": "APHIDS, LEAF MINER",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "RAJASTHAN, GUJARAT",
    "details": "APHIDS MAJOR CONSTRAINT. ",
    "index": "64",
    "hi": {
      "name": "मेथी",
      "pest": "माहू, पत्ती सुरंगक"
    },
    "gu": {
      "name": "મેથીની ભાજી",
      "pest": "મોલો, પાન કોરિયું"
    }
  },
  {
    "name": "AMARANTH LEAVES",
    "category": "VEGETABLE",
    "pest": "LEAF WEBBER, STEM WEEVIL",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "TN, KERALA",
    "details": "HYMENIA RECURVALIS WEBS LEAVES. ",
    "index": "65",
    "hi": {
      "name": "चौलाई",
      "pest": "पत्ती जालक, तना घुन"
    },
    "gu": {
      "name": "તાંદળજો",
      "pest": "પાન જાળિયું, થડ ઘૈણ"
    }
  },
  {
    "name": "LETTUCE",
    "category": "VEGETABLE",
    "pest": "APHIDS, LOOPERS",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "NILGIRIS, PERI-URBAN",
    "details": "APHIDS VECTOR VIRUSES. ",
    "index": "66",
    "hi": {
      "name": "सलाद पत्ता",
      "pest": "माहू, लूपर"
    },
    "gu": {
      "name": "લેટીસ",
      "pest": "મોલો, લૂપર"
    }
  },
  {
    "name": "CARROT",
    "category": "VEGETABLE",
    "pest": "CARROT FLY, APHIDS",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "HARYANA, PUNJAB, UP",
    "details": "ROOT DAMAGE BY FLY MAGGOTS. ",
    "index": "67",
    "hi": {
      "name": "गाजर",
      "pest": "गाजर मक्खी, माहू"
    },
    "gu": {
      "name": "ગાજર",
      "pest": "ગાજર માખી, મોલો"
    }
  },
  {
    "name": "RADISH",
    "category": "VEGETABLE",
    "pest": "APHIDS, FLEA BEETLE, MUSTARD SAWFLY",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "WB, BIHAR",
    "details": "FLEA BEETLES MAKE SHOT HOLES. ",
    "index": "68",
    "hi": {
      "name": "मूली",
      "pest": "माहू, पिस्सू भृंग, सरसों आरा मक्खी"
    },
    "gu": {
      "name": "મૂળા",
      "pest": "મોલો, ચાંચડ ભમરો, રાઈ કરવત માખી"
    }
  },
  {
    "name": "TURNIP",
    "category": "VEGETABLE",
    "pest": "APHIDS, SAWFLY",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "PUNJAB, HP",
    "details": "CRUCIFEROUS PESTS. ",
    "index": "69",
    "hi": {
      "name": "शलजम",
      "pest": "माहू, आरा मक्खी"
    },
    "gu": {
      "name": "સલગમ",
      "pest": "મોલો, કરવત માખી"
    }
  },
  {
    "name": "BEETROOT",
    "category": "VEGETABLE",
    "pest": "LEAF MINER, WEBWORMS, BEET ARMYWORM",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "TN, MAHARASHTRA",
    "details": "SPODOPTERA EXIGUA KEY PEST. ",
    "index": "70",
    "hi": {
      "name": "चुकंदर",
      "pest": "पत्ती सुरंगक, जाल इल्ली, चुकंदर सैन्य कीट"
    },
    "gu": {
      "name": "બીટ",
      "pest": "પાન કોરિયું, જાળ ઈયળ, બીટ લશ્કરી ઈયળ"
    }
  },
  {
    "name": "CUCUMBER",
    "category": "VEGETABLE",
    "pest": "FRUIT FLY, RED PUMPKIN BEETLE, APHIDS",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "KARNATAKA, AP",
    "details": "BACTROCERA CUCURBITAE PUNCTURES FRUIT. ",
    "index": "71",
    "hi": {
      "name": "खीरा",
      "pest": "फल मक्खी, लाल कद्दू भृंग, माहू"
    },
    "gu": {
      "name": "કાકડી",
      "pest": "ફળ માખી, લાલ કોળું ભમરો, મોલો"
    }
  },
  {
    "name": "PUMPKIN",
    "category": "VEGETABLE",
    "pest": "RED PUMPKIN BEETLE, FRUIT FLY, PUMPKIN CATERPILLAR",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "UP, WB",
    "details": "DIAPHANIA INDICA MOTHS NIGHT ACTIVE. ",
    "index": "72",
    "hi": {
      "name": "कद्दू",
      "pest": "लाल कद्दू भृंग, फल मक्खी, कद्दू इल्ली"
    },
    "gu": {
      "name": "કોળું",
      "pest": "લાલ કોળું ભમરો, ફળ માખી, કોળું ઈયળ"
    }
  },
  {
    "name": "BOTTLE GOURD",
    "category": "VEGETABLE",
    "pest": "FRUIT FLY, PLUME MOTH, RED PUMPKIN BEETLE",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "UP, BIHAR",
    "details": "FRUIT FLY CAUSES ROTTING. PLUME MOTH BORES FRUIT. ",
    "index": "73",
    "hi": {
      "name": "लौकी",
      "pest": "फल मक्खी, प्लूम पतंगा, लाल कद्दू भृंग"
    },
    "gu": {
      "name": "દૂધી",
      "pest": "ફળ માખી, પ્લૂમ પતંગિયું, લાલ કોળું ભમરો"
    }
  },
  {
    "name": "BITTER GOURD",
    "category": "VEGETABLE",
    "pest": "FRUIT FLY, EPILACHNA BEETLE, LEAF CATERPILLAR",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "MAHARASHTRA, KERALA",
    "details": "BACTROCERA CUCURBITAE SEVERE. HADDA BEETLE EATS LEAVES. ",
    "index": "74",
    "hi": {
      "name": "करेला",
      "pest": "फल मक्खी, एपिलैक्ना भृंग, पत्ती इल्ली"
    },
    "gu": {
      "name": "કારેલાં",
      "pest": "ફળ માખી, એપિલેકના ભમરો, પાન ઈયળ"
    }
  },
  {
    "name": "RIDGE GOURD",
    "category": "VEGETABLE",
    "pest": "FRUIT FLY, LEAF MINER",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "AP, KARNATAKA",
    "details": "FRUIT FLY MAJOR CONSTRAINT. ",
    "index": "75",
    "hi": {
      "name": "तोरई",
      "pest": "फल मक्खी, पत्ती सुरंगक"
    },
    "gu": {
      "name": "તુરિયા",
      "pest": "ફળ માખી, પાન કોરિયું"
    }
  },
  {
    "name": "SPONGE GOURD",
    "category": "VEGETABLE",
    "pest": "FRUIT FLY, LEAF MINER",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "UP, BIHAR",
    "details": "SIMILAR TO RIDGE GOURD. ",
    "index": "76",
    "hi": {
      "name": "गिलकी",
      "pest": "फल मक्खी, पत्ती सुरंगक"
    },
    "gu": {
      "name": "ગલકાં",
      "pest": "ફળ માખી, પાન કોરિયું"
    }
  },
  {
    "name": "SNAKE GOURD",
    "category": "VEGETABLE",
    "pest": "SNAKE GOURD SEMILOOPER, FRUIT FLY",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "KERALA, TN",
    "details": "ANADEVIDIA PEPONIS DEFOLIATES. ",
    "index": "77",
    "hi": {
      "name": "चिचिंडा",
      "pest": "चिचिंडा सेमीलूपर, फल मक्खी"
    },
    "gu": {
      "name": "પડવળ",
      "pest": "પડવળ સેમિલૂપર, ફળ માખી"
    }
  },
  {
    "name": "ASH GOURD",
    "category": "VEGETABLE",
    "pest": "FRUIT FLY, PUMPKIN BEETLE",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "TN, KARNATAKA",
    "details": "FRUIT FLY DAMAGE COMMON. ",
    "index": "78",
    "hi": {
      "name": "पेठा",
      "pest": "फल मक्खी, कद्दू भृंग"
    },
    "gu": {
      "name": "ભૂરું કોળું",
      "pest": "ફળ માખી, કોળું ભમરો"
    }
  },
  {
    "name": "POINTED GOURD",
    "category": "VEGETABLE",
    "pest": "FRUIT FLY, STEM BORER, VINE BORER",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "BIHAR, WB, UP",
    "details": "VINE BORERS CAUSE DRYING. ",
    "index": "79",
    "hi": {
      "name": "परवल",
      "pest": "फल मक्खी, तना छेदक, बेल छेदक"
    },
    "gu": {
      "name": "પરવળ",
      "pest": "ફળ માખી, થડ ભેદક, વેલ ભેદક"
    }
  },
  {
    "name": "PEAS",
    "category": "VEGETABLE",
    "pest": "POD BORER, PEA APHID, LEAF MINER",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "UP, MP",
    "details": "HELICOVERPA & ETIELLA BORE PODS. ",
    "index": "80",
    "hi": {
      "name": "मटर",
      "pest": "फली छेदक, मटर माहू, पत्ती सुरंगक"
    },
    "gu": {
      "name": "વટાણા",
      "pest": "શીંગ ભેદક, વટાણા મોલો, પાન કોરિયું"
    }
  },
  {
    "name": "FRENCH BEANS",
    "category": "VEGETABLE",
    "pest": "BEAN FLY, APHIDS, POD BORER",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "MAHARASHTRA, KARNATAKA",
    "details": "OPHIOMYIA PHASEOLI ATTACKS STEMS. ",
    "index": "81",
    "hi": {
      "name": "फ्रेंच बीन्स",
      "pest": "बीन मक्खी, माहू, फली छेदक"
    },
    "gu": {
      "name": "ફ્રેન્ચ બીન્સ",
      "pest": "બીન માખી, મોલો, શીંગ ભેદક"
    }
  },
  {
    "name": "YARDLONG BEANS",
    "category": "VEGETABLE",
    "pest": "POD BORER, APHIDS, BEAN FLY",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "KERALA, TN",
    "details": "MARUCA VITRATA WEBS FLOWERS/PODS. ",
    "index": "82",
    "hi": {
      "name": "बरबटी",
      "pest": "फली छेदक, माहू, बीन मक्खी"
    },
    "gu": {
      "name": "ચોળી",
      "pest": "શીંગ ભેદક, મોલો, બીન માખી"
    }
  },
  {
    "name": "DRUMSTICK (MORINGA)",
    "category": "VEGETABLE",
    "pest": "BUD WORM, HAIRY CATERPILLAR, POD FLY, LEAF CATERPILLAR",
    "on": "7:00 PM",
    "off": "11:00 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "TN, AP, KARNATAKA",
    "details": "EUPTEROTE MOLLIFERA CONGREGATES ON TRUNKS. NOORDA SPECIES MOTHS NOCTURNAL. ",
    "index": "83",
    "hi": {
      "name": "सहजन",
      "pest": "कली इल्ली, रोमिल इल्ली, फली मक्खी, पत्ती इल्ली"
    },
    "gu": {
      "name": "સરગવો",
      "pest": "કળી ઈયળ, રુવાંટીવાળી ઈયળ, શીંગ માખી, પાન ઈયળ"
    }
  },
  {
    "name": "JACKFRUIT (VEG)",
    "category": "VEGETABLE",
    "pest": "SHOOT & FRUIT BORER, SPITTLE BUG",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "KERALA, TN, NE",
    "details": "DIAPHANIA CAESALIS KEY PEST. ",
    "index": "84",
    "hi": {
      "name": "कटहल",
      "pest": "प्ररोह व फल छेदक, स्पिटल बग"
    },
    "gu": {
      "name": "ફણસ",
      "pest": "ડૂંખ અને ફળ ભેદક, સ્પિટલ બગ"
    }
  },
  {
    "name": "COLOCASIA (ARBI)",
    "category": "VEGETABLE",
    "pest": "LEAF EATING CATERPILLAR, APHIDS",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "UP, BIHAR, KERALA",
    "details": "SPODOPTERA LITURA DEFOLIATES. ",
    "index": "85",
    "hi": {
      "name": "अरबी",
      "pest": "पत्ती खाने वाली इल्ली, माहू"
    },
    "gu": {
      "name": "અળવી",
      "pest": "પાન ખાનાર ઈયળ, મોલો"
    }
  },
  {
    "name": "MANGO",
    "category": "FRUIT",
    "pest": "MANGO HOPPER, FRUIT FLY, STEM BORER, STONE WEEVIL",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "UP, AP, BIHAR, MAHARASHTRA",
    "details": "AMRITODUS HOPPER ACTIVE FLOWERING. BACTROCERA FLY PEAKS SUMMER. STEM BORER BEETLES LARGE/NOCTURNAL. ",
    "index": "86",
    "hi": {
      "name": "आम",
      "pest": "आम फुदका, फल मक्खी, तना छेदक, गुठली घुन"
    },
    "gu": {
      "name": "કેરી",
      "pest": "કેરી ચૂસિયો, ફળ માખી, થડ ભેદક, ગોટલી ઘૈણ"
    }
  },
  {
    "name": "BANANA",
    "category": "FRUIT",
    "pest": "RHIZOME WEEVIL, PSEUDOSTEM WEEVIL, APHID, THRIPS",
    "on": "7:30 PM",
    "off": "11:30 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "TN, MAHARASHTRA, GUJARAT, KERALA",
    "details": "WEEVILS (COSMOPOLITES) NOCTURNAL; LIGHT/PHEROMONE ATTRACTION. APHID VECTORS BUNCHY TOP. ",
    "index": "87",
    "hi": {
      "name": "केला",
      "pest": "प्रकंद घुन, तना घुन, माहू, थ्रिप्स"
    },
    "gu": {
      "name": "કેળાં",
      "pest": "ગાંઠ ઘૈણ, થડ ઘૈણ, મોલો, થ્રિપ્સ"
    }
  },
  {
    "name": "APPLE",
    "category": "FRUIT",
    "pest": "WOOLLY APHID, SAN JOSE SCALE, CODLING MOTH, STEM BORER",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "J&K, HP",
    "details": "CYDIA POMONELLA KEY; MOTHS FLY AT DUSK. ",
    "index": "88",
    "hi": {
      "name": "सेब",
      "pest": "ऊनी माहू, सैन जोस स्केल, कोडलिंग पतंगा, तना छेदक"
    },
    "gu": {
      "name": "સફરજન",
      "pest": "ઊની મોલો, સેન જોસ ચીકટો, કોડલિંગ પતંગિયું, થડ ભેદક"
    }
  },
  {
    "name": "ORANGE",
    "category": "FRUIT",
    "pest": "CITRUS PSYLLA, LEAF MINER, FRUIT SUCKING MOTH, WHITEFLY",
    "on": "7:00 PM",
    "off": "11:00 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "MAHARASHTRA, PUNJAB, NE INDIA",
    "details": "EUDOCIMA PIERCES FRUIT AT NIGHT. DIAPHORINA (PSYLLA) VECTORS GREENING. ",
    "index": "89",
    "hi": {
      "name": "संतरा",
      "pest": "नींबू सिल्ला, पत्ती सुरंगक, फल चूसक पतंगा, सफेद मक्खी"
    },
    "gu": {
      "name": "સંતરા",
      "pest": "સાયલા, પાન કોરિયું, ફળ ચૂસનાર પતંગિયું, સફેદમાખી"
    }
  },
  {
    "name": "MOSAMBI",
    "category": "FRUIT",
    "pest": "LEAF MINER, PSYLLA, FRUIT SUCKING MOTH",
    "on": "7:00 PM",
    "off": "11:00 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "MAHARASHTRA, AP",
    "details": "SIMILAR TO ORANGE. MINER DAMAGES FLUSH. ",
    "index": "90",
    "hi": {
      "name": "मौसंबी",
      "pest": "पत्ती सुरंगक, सिल्ला, फल चूसक पतंगा"
    },
    "gu": {
      "name": "મોસંબી",
      "pest": "પાન કોરિયું, સાયલા, ફળ ચૂસનાર પતંગિયું"
    }
  },
  {
    "name": "LEMON",
    "category": "FRUIT",
    "pest": "CITRUS BUTTERFLY, LEAF MINER, PSYLLA",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "AP, GUJARAT",
    "details": "PAPILIO DEMOLEUS LARVAE DEFOLIATE. ",
    "index": "91",
    "hi": {
      "name": "नींबू",
      "pest": "नींबू तितली, पत्ती सुरंगक, सिल्ला"
    },
    "gu": {
      "name": "લીંબુ",
      "pest": "લીંબુ પતંગિયું, પાન કોરિયું, સાયલા"
    }
  },
  {
    "name": "LIME",
    "category": "FRUIT",
    "pest": "CITRUS BUTTERFLY, LEAF MINER, MITES",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "AP, GUJARAT",
    "details": "ACID LIME PEST COMPLEX. ",
    "index": "92",
    "hi": {
      "name": "कागजी नींबू",
      "pest": "नींबू तितली, पत्ती सुरंगक, माइट"
    },
    "gu": {
      "name": "કાગદી લીંબુ",
      "pest": "લીંબુ પતંગિયું, પાન કોરિયું, કથીરી"
    }
  },
  {
    "name": "GRAPES",
    "category": "FRUIT",
    "pest": "THRIPS, MEALYBUG, STEM GIRDLER, FLEA BEETLE",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "MAHARASHTRA, KARNATAKA",
    "details": "SCIRTOTHRIPS & RHIPIPHOROTHRIPS SCAR BERRIES. FLEA BEETLES FEED ON BUDS. ",
    "index": "93",
    "hi": {
      "name": "अंगूर",
      "pest": "थ्रिप्स, मिलीबग, तना गर्डलर, पिस्सू भृंग"
    },
    "gu": {
      "name": "દ્રાક્ષ",
      "pest": "થ્રિપ્સ, મિલીબગ, થડ ગર્ડલર, ચાંચડ ભમરો"
    }
  },
  {
    "name": "GUAVA",
    "category": "FRUIT",
    "pest": "FRUIT FLY, BARK EATING CATERPILLAR, TEA MOSQUITO BUG",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "UP, BIHAR, MAHARASHTRA",
    "details": "BACTROCERA FLIES SEVERE. HELOPELTIS DAMAGES FRUIT SURFACE. ",
    "index": "94",
    "hi": {
      "name": "अमरूद",
      "pest": "फल मक्खी, छाल खाने वाली इल्ली, चाय मच्छर बग"
    },
    "gu": {
      "name": "જામફળ",
      "pest": "ફળ માખી, છાલ ખાનાર ઈયળ, ચા મચ્છર બગ"
    }
  },
  {
    "name": "PAPAYA",
    "category": "FRUIT",
    "pest": "MEALYBUG, WHITEFLY, APHIDS",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "AP, GUJARAT, KARNATAKA",
    "details": "PARACOCCUS MARGINATUS INVASIVE. WHITEFLIES VECTOR LEAF CURL. ",
    "index": "95",
    "hi": {
      "name": "पपीता",
      "pest": "मिलीबग, सफेद मक्खी, माहू"
    },
    "gu": {
      "name": "પપૈયાં",
      "pest": "મિલીબગ, સફેદમાખી, મોલો"
    }
  },
  {
    "name": "PINEAPPLE",
    "category": "FRUIT",
    "pest": "MEALYBUG",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "WB, NE INDIA, KERALA",
    "details": "MEALYBUGS CAUSE WILT. ",
    "index": "96",
    "hi": {
      "name": "अनानास",
      "pest": "मिलीबग"
    },
    "gu": {
      "name": "અનાનસ",
      "pest": "મિલીબગ"
    }
  },
  {
    "name": "POMEGRANATE",
    "category": "FRUIT",
    "pest": "FRUIT BORER, THRIPS, APHIDS",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "MAHARASHTRA, KARNATAKA, GUJARAT",
    "details": "DEUDORIX ISOCRATES LARVAE BORE FRUIT. BAGGING EFFECTIVE. ",
    "index": "97",
    "hi": {
      "name": "अनार",
      "pest": "फल छेदक, थ्रिप्स, माहू"
    },
    "gu": {
      "name": "દાડમ",
      "pest": "ફળ ભેદક, થ્રિપ્સ, મોલો"
    }
  },
  {
    "name": "WATERMELON",
    "category": "FRUIT",
    "pest": "FRUIT FLY, RED PUMPKIN BEETLE, THRIPS",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "UP, AP",
    "details": "FRUIT FLY CAUSES ROTTING. THRIPS VECTOR BUD NECROSIS. ",
    "index": "98",
    "hi": {
      "name": "तरबूज",
      "pest": "फल मक्खी, लाल कद्दू भृंग, थ्रिप्स"
    },
    "gu": {
      "name": "તડબૂચ",
      "pest": "ફળ માખી, લાલ કોળું ભમરો, થ્રિપ્સ"
    }
  },
  {
    "name": "MUSKMELON",
    "category": "FRUIT",
    "pest": "FRUIT FLY, PUMPKIN BEETLE",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "UP, PUNJAB",
    "details": "BACTROCERA CUCURBITAE MAIN PEST. ",
    "index": "99",
    "hi": {
      "name": "खरबूजा",
      "pest": "फल मक्खी, कद्दू भृंग"
    },
    "gu": {
      "name": "ટેટી",
      "pest": "ફળ માખી, કોળું ભમરો"
    }
  },
  {
    "name": "PEAR",
    "category": "FRUIT",
    "pest": "FRUIT FLY, APHIDS, SCALE",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "J&K, HP",
    "details": "SIMILAR TO APPLE PESTS. ",
    "index": "100",
    "hi": {
      "name": "नाशपाती",
      "pest": "फल मक्खी, माहू, स्केल कीट"
    },
    "gu": {
      "name": "નાસપતી",
      "pest": "ફળ માખી, મોલો, ચીકટો"
    }
  },
  {
    "name": "PEACH",
    "category": "FRUIT",
    "pest": "FRUIT FLY, LEAF CURL APHID",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "PUNJAB, UTTARAKHAND",
    "details": "BACTROCERA ZONATA SEVERE. ",
    "index": "101",
    "hi": {
      "name": "आड़ू",
      "pest": "फल मक्खी, पत्ती मरोड़ माहू"
    },
    "gu": {
      "name": "આલૂ",
      "pest": "ફળ માખી, પાન વળાંક મોલો"
    }
  },
  {
    "name": "PLUM",
    "category": "FRUIT",
    "pest": "PLUM FRUIT MOTH, APHIDS",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "HP",
    "details": "FRUIT MOTH LARVAE BORE FRUIT. ",
    "index": "102",
    "hi": {
      "name": "आलूबुखारा",
      "pest": "आलूबुखारा फल पतंगा, माहू"
    },
    "gu": {
      "name": "આલૂબુખાર",
      "pest": "આલૂબુખાર ફળ પતંગિયું, મોલો"
    }
  },
  {
    "name": "APRICOT",
    "category": "FRUIT",
    "pest": "CHAFFER BEETLE, FRUIT BORER",
    "on": "7:30 PM",
    "off": "10:30 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "LADAKH, HP",
    "details": "BEETLES FEED FOLIAGE/FRUIT AT NIGHT. ",
    "index": "103",
    "hi": {
      "name": "खुबानी",
      "pest": "चेफर भृंग, फल छेदक"
    },
    "gu": {
      "name": "જરદાળુ",
      "pest": "ચેફર ભમરો, ફળ ભેદક"
    }
  },
  {
    "name": "CHERRY",
    "category": "FRUIT",
    "pest": "STEM BORER, FRUIT FLY",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "J&K",
    "details": "STEM BORERS DAMAGE TRUNKS. ",
    "index": "104",
    "hi": {
      "name": "चेरी",
      "pest": "तना छेदक, फल मक्खी"
    },
    "gu": {
      "name": "ચેરી",
      "pest": "થડ ભેદક, ફળ માખી"
    }
  },
  {
    "name": "STRAWBERRY",
    "category": "FRUIT",
    "pest": "WHITE GRUB, THRIPS, CUTWORM",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "MAHARASHTRA, HP",
    "details": "SOIL PESTS DAMAGE ROOTS. ",
    "index": "105",
    "hi": {
      "name": "स्ट्रॉबेरी",
      "pest": "सफेद गिडार, थ्रिप्स, कटवर्म"
    },
    "gu": {
      "name": "સ્ટ્રોબેરી",
      "pest": "ધૈણ, થ્રિપ્સ, કાતરા"
    }
  },
  {
    "name": "BLUEBERRY",
    "category": "FRUIT",
    "pest": "SPOTTED WING DROSOPHILA",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "LIMITED (HILLS)",
    "details": "EMERGING CROP. ",
    "index": "106",
    "hi": {
      "name": "ब्लूबेरी",
      "pest": "चित्तीदार पंख ड्रोसोफिला"
    },
    "gu": {
      "name": "બ્લૂબેરી",
      "pest": "ટપકાંવાળી પાંખ ડ્રોસોફિલા"
    }
  },
  {
    "name": "JACKFRUIT",
    "category": "FRUIT",
    "pest": "SHOOT & FRUIT BORER, SPITTLE BUG, BUD WEEVIL",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "KERALA, TN, KARNATAKA, ASSAM",
    "details": "DIAPHANIA CAESALIS BORES SHOOTS/FRUIT. OCHYROMERA WEEVIL AFFECTS FRUIT SET. ",
    "index": "107",
    "hi": {
      "name": "कटहल",
      "pest": "प्ररोह व फल छेदक, स्पिटल बग, कली घुन"
    },
    "gu": {
      "name": "ફણસ",
      "pest": "ડૂંખ અને ફળ ભેદક, સ્પિટલ બગ, કળી ઘૈણ"
    }
  },
  {
    "name": "SAPOTA (CHIKOO)",
    "category": "FRUIT",
    "pest": "CHIKU MOTH, SEED BORER, FRUIT FLY",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "GUJARAT, MAHARASHTRA, KARNATAKA",
    "details": "NEPHOPTERYX MOTH WEBS LEAVES. BACTROCERA ATTACKS RIPE FRUIT. ",
    "index": "108",
    "hi": {
      "name": "चीकू",
      "pest": "चीकू पतंगा, बीज छेदक, फल मक्खी"
    },
    "gu": {
      "name": "ચીકુ",
      "pest": "ચીકુ પતંગિયું, બીજ ભેદક, ફળ માખી"
    }
  },
  {
    "name": "CUSTARD APPLE",
    "category": "FRUIT",
    "pest": "MEALYBUG, FRUIT BORER",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "MAHARASHTRA, AP",
    "details": "MEALYBUGS COVER FRUIT. ANONAEPESTIS BORES FRUIT. ",
    "index": "109",
    "hi": {
      "name": "सीताफल",
      "pest": "मिलीबग, फल छेदक"
    },
    "gu": {
      "name": "સીતાફળ",
      "pest": "મિલીબગ, ફળ ભેદક"
    }
  },
  {
    "name": "SUGAR APPLE",
    "category": "FRUIT",
    "pest": "MEALYBUG, FRUIT BORER",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "MAHARASHTRA",
    "details": "SAME AS CUSTARD APPLE. ",
    "index": "110",
    "hi": {
      "name": "शरीफा",
      "pest": "मिलीबग, फल छेदक"
    },
    "gu": {
      "name": "શરીફા",
      "pest": "મિલીબગ, ફળ ભેદક"
    }
  },
  {
    "name": "SOURSOP",
    "category": "FRUIT",
    "pest": "MEALYBUG, SCALE",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "KERALA, KARNATAKA",
    "details": "MINOR CROP; SIMILAR PESTS TO CUSTARD APPLE. ",
    "index": "111",
    "hi": {
      "name": "लक्ष्मणफल",
      "pest": "मिलीबग, स्केल कीट"
    },
    "gu": {
      "name": "લક્ષ્મણફળ",
      "pest": "મિલીબગ, ચીકટો"
    }
  },
  {
    "name": "LYCHEE",
    "category": "FRUIT",
    "pest": "FRUIT BORER, MITES, BARK EATING CATERPILLAR",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "BIHAR, WB",
    "details": "CONOPOMORPHA SINENSIS KEY. ERINOSE MITE CAUSES GALLS. ",
    "index": "112",
    "hi": {
      "name": "लीची",
      "pest": "फल छेदक, माइट, छाल खाने वाली इल्ली"
    },
    "gu": {
      "name": "લીચી",
      "pest": "ફળ ભેદક, કથીરી, છાલ ખાનાર ઈયળ"
    }
  },
  {
    "name": "LONGAN",
    "category": "FRUIT",
    "pest": "FRUIT BORER, LITCHI STINK BUG",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "WB, BIHAR",
    "details": "RELATED TO LITCHI PESTS. ",
    "index": "113",
    "hi": {
      "name": "लोंगन",
      "pest": "फल छेदक, लीची गंध बग"
    },
    "gu": {
      "name": "લોંગન",
      "pest": "ફળ ભેદક, લીચી ગંધ બગ"
    }
  },
  {
    "name": "RAMBUTAN",
    "category": "FRUIT",
    "pest": "MEALYBUG, FRUIT BORER, LEAF WEBBER",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "KERALA, KARNATAKA",
    "details": "FRUIT BORER DAMAGES ARIL. ",
    "index": "114",
    "hi": {
      "name": "रामबूटान",
      "pest": "मिलीबग, फल छेदक, पत्ती जालक"
    },
    "gu": {
      "name": "રામ્બુટાન",
      "pest": "મિલીબગ, ફળ ભેદક, પાન જાળિયું"
    }
  },
  {
    "name": "COCONUT",
    "category": "FRUIT",
    "pest": "RHINOCEROS BEETLE, RED PALM WEEVIL, BLACK HEADED CATERPILLAR",
    "on": "7:00 PM",
    "off": "11:00 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "KERALA, TN, KARNATAKA, AP",
    "details": "ORYCTES ADULTS LIGHT-ATTRACTED. OPISINA DEFOLIATES. ",
    "index": "115",
    "hi": {
      "name": "नारियल",
      "pest": "गैंडा भृंग, लाल ताड़ घुन, काला सिर इल्ली"
    },
    "gu": {
      "name": "નાળિયેર",
      "pest": "ગેંડા ભમરો, લાલ તાડ ઘૈણ, કાળા માથાની ઈયળ"
    }
  },
  {
    "name": "ARECANUT",
    "category": "FRUIT",
    "pest": "SPINDLE BUG, MITES, INFLORESCENCE CATERPILLAR",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "KARNATAKA, KERALA, ASSAM",
    "details": "CARVALHOIA BUG SUCKS SAP. CATERPILLAR DAMAGES FLOWERS. ",
    "index": "116",
    "hi": {
      "name": "सुपारी",
      "pest": "स्पिंडल बग, माइट, पुष्पक्रम इल्ली"
    },
    "gu": {
      "name": "સોપારી",
      "pest": "સ્પિન્ડલ બગ, કથીરી, ફૂલગુચ્છ ઈયળ"
    }
  },
  {
    "name": "DATE PALM",
    "category": "FRUIT",
    "pest": "RED PALM WEEVIL, SCALE INSECT",
    "on": "7:00 PM",
    "off": "11:00 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "GUJARAT, RAJASTHAN",
    "details": "RHYNCHOPHORUS (RPW) LETHAL; PHEROMONE/KAIROMONE ATTRACTION. ",
    "index": "117",
    "hi": {
      "name": "खजूर",
      "pest": "लाल ताड़ घुन, स्केल कीट"
    },
    "gu": {
      "name": "ખજૂર",
      "pest": "લાલ તાડ ઘૈણ, ચીકટો"
    }
  },
  {
    "name": "FIG",
    "category": "FRUIT",
    "pest": "STEM BORER, FRUIT FLY, MITES",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "MAHARASHTRA, KARNATAKA",
    "details": "BATOCERA BORES STEM. ",
    "index": "118",
    "hi": {
      "name": "अंजीर",
      "pest": "तना छेदक, फल मक्खी, माइट"
    },
    "gu": {
      "name": "અંજીર",
      "pest": "થડ ભેદક, ફળ માખી, કથીરી"
    }
  },
  {
    "name": "JAMUN",
    "category": "FRUIT",
    "pest": "LEAF WEBBER, FRUIT FLY, LEAF MINER",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "MAHARASHTRA, UP",
    "details": "CAREA SUBTILIS DEFOLIATES. ",
    "index": "119",
    "hi": {
      "name": "जामुन",
      "pest": "पत्ती जालक, फल मक्खी, पत्ती सुरंगक"
    },
    "gu": {
      "name": "જાંબુ",
      "pest": "પાન જાળિયું, ફળ માખી, પાન કોરિયું"
    }
  },
  {
    "name": "BER (ZIZIPHUS)",
    "category": "FRUIT",
    "pest": "FRUIT FLY, FRUIT BORER, CHAFER BEETLE",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "RAJASTHAN, HARYANA, PUNJAB",
    "details": "CARPOMYIA FRUIT FLY SPECIFIC. BEETLES FEED NIGHT. ",
    "index": "120",
    "hi": {
      "name": "बेर",
      "pest": "फल मक्खी, फल छेदक, चेफर भृंग"
    },
    "gu": {
      "name": "બોર",
      "pest": "ફળ માખી, ફળ ભેદક, ચેફર ભમરો"
    }
  },
  {
    "name": "AMLA",
    "category": "FRUIT",
    "pest": "BARK EATING CATERPILLAR, FRUIT BORER",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "UP, TN",
    "details": "INDARBELA FEEDS ON BARK. ",
    "index": "121",
    "hi": {
      "name": "आंवला",
      "pest": "छाल खाने वाली इल्ली, फल छेदक"
    },
    "gu": {
      "name": "આમળાં",
      "pest": "છાલ ખાનાર ઈયળ, ફળ ભેદક"
    }
  },
  {
    "name": "BAEL",
    "category": "FRUIT",
    "pest": "LEAF MINER, FRUIT FLY",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "UP, BIHAR",
    "details": "FRUIT FLY CAUSES DROP. ",
    "index": "122",
    "hi": {
      "name": "बेल",
      "pest": "पत्ती सुरंगक, फल मक्खी"
    },
    "gu": {
      "name": "બીલી",
      "pest": "પાન કોરિયું, ફળ માખી"
    }
  },
  {
    "name": "AVOCADO",
    "category": "FRUIT",
    "pest": "TEA MOSQUITO BUG, FRUIT FLY, THRIPS, SCALES",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "TN (HILLS), KERALA, KARNATAKA",
    "details": "HELOPELTIS SCABS FRUIT. BACTROCERA ATTACKS. ",
    "index": "123",
    "hi": {
      "name": "एवोकाडो",
      "pest": "चाय मच्छर बग, फल मक्खी, थ्रिप्स, स्केल कीट"
    },
    "gu": {
      "name": "એવોકાડો",
      "pest": "ચા મચ્છર બગ, ફળ માખી, થ્રિપ્સ, ચીકટો"
    }
  },
  {
    "name": "DRAGON FRUIT",
    "category": "FRUIT",
    "pest": "THRIPS, MEALYBUG, APHIDS, FRUIT FLY",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "GUJARAT, MAHARASHTRA, KARNATAKA, AP",
    "details": "THRIPS SCAR FRUIT. ANTS PROTECT MEALYBUGS. ",
    "index": "124",
    "hi": {
      "name": "ड्रैगन फ्रूट",
      "pest": "थ्रिप्स, मिलीबग, माहू, फल मक्खी"
    },
    "gu": {
      "name": "ડ્રેગન ફ્રૂટ",
      "pest": "થ્રિપ્સ, મિલીબગ, મોલો, ફળ માખી"
    }
  },
  {
    "name": "ROSE",
    "category": "FLOWER",
    "pest": "THRIPS, APHIDS, BUD BORER, SCALE",
    "on": "6:00 PM",
    "off": "10:00 PM",
    "duration": "4:00",
    "light": "WARM",
    "region": "KARNATAKA, MAHARASHTRA, TN",
    "details": "SCIRTOTHRIPS DISCOLORS PETALS. HELICOVERPA BORES BUDS. ",
    "index": "125",
    "hi": {
      "name": "गुलाब",
      "pest": "थ्रिप्स, माहू, कली छेदक, स्केल कीट"
    },
    "gu": {
      "name": "ગુલાબ",
      "pest": "થ્રિપ્સ, મોલો, કળી ભેદક, ચીકટો"
    }
  },
  {
    "name": "LOTUS",
    "category": "FLOWER",
    "pest": "CUTWORMS, APHIDS, LEAF EATING CATERPILLAR",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "TN, KARNATAKA",
    "details": "SPODOPTERA LARVAE FEED ON LEAVES. ",
    "index": "126",
    "hi": {
      "name": "कमल",
      "pest": "कटवर्म, माहू, पत्ती खाने वाली इल्ली"
    },
    "gu": {
      "name": "કમળ",
      "pest": "કાતરા, મોલો, પાન ખાનાર ઈયળ"
    }
  },
  {
    "name": "JASMINE",
    "category": "FLOWER",
    "pest": "BUD WORM, GALLERY WORM, BLOSSOM MIDGE",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "TN, KARNATAKA",
    "details": "HENDECASIS BUD WORM SEVERE; MOTHS LAY EGGS ON BUDS. ",
    "index": "127",
    "hi": {
      "name": "चमेली",
      "pest": "कली इल्ली, गैलरी इल्ली, पुष्प मिज"
    },
    "gu": {
      "name": "મોગરો",
      "pest": "કળી ઈયળ, ગેલેરી ઈયળ, ફૂલ મિજ"
    }
  },
  {
    "name": "TUBEROSE",
    "category": "FLOWER",
    "pest": "BUD BORER, THRIPS, APHIDS",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "WB, KARNATAKA, MAHARASHTRA",
    "details": "HELICOVERPA ATTACKS BUDS. THRIPS AFFECT QUALITY. ",
    "index": "128",
    "hi": {
      "name": "रजनीगंधा",
      "pest": "कली छेदक, थ्रिप्स, माहू"
    },
    "gu": {
      "name": "ગુલછડી",
      "pest": "કળી ભેદક, થ્રિપ્સ, મોલો"
    }
  },
  {
    "name": "MARIGOLD",
    "category": "FLOWER",
    "pest": "BUD BORER, THRIPS, HAIRY CATERPILLAR",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "KARNATAKA, AP, MAHARASHTRA",
    "details": "HELICOVERPA FEEDS ON FLOWERS. TRAP CROP FOR BORERS. ",
    "index": "129",
    "hi": {
      "name": "गेंदा",
      "pest": "कली छेदक, थ्रिप्स, रोमिल इल्ली"
    },
    "gu": {
      "name": "ગલગોટા",
      "pest": "કળી ભેદક, થ્રિપ્સ, રુવાંટીવાળી ઈયળ"
    }
  },
  {
    "name": "CHRYSANTHEMUM",
    "category": "FLOWER",
    "pest": "APHIDS, THRIPS, BUD BORER",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "TN, KARNATAKA",
    "details": "APHIDS MAJOR SUCKING PEST. ",
    "index": "130",
    "hi": {
      "name": "गुलदाउदी",
      "pest": "माहू, थ्रिप्स, कली छेदक"
    },
    "gu": {
      "name": "સેવંતી",
      "pest": "મોલો, થ્રિપ્સ, કળી ભેદક"
    }
  },
  {
    "name": "GLADIOLUS",
    "category": "FLOWER",
    "pest": "THRIPS, CUTWORM, BORERS",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "WB, PUNJAB",
    "details": "THRIPS IN SHEATHS. CUTWORMS DAMAGE SPIKES. ",
    "index": "131",
    "hi": {
      "name": "ग्लैडियोलस",
      "pest": "थ्रिप्स, कटवर्म, छेदक"
    },
    "gu": {
      "name": "ગ્લેડિયોલસ",
      "pest": "થ્રિપ્સ, કાતરા, ભેદક"
    }
  },
  {
    "name": "GERBERA",
    "category": "FLOWER",
    "pest": "WHITEFLY, THRIPS, LEAF MINER, MITES",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "MAHARASHTRA, KARNATAKA",
    "details": "POLYHOUSE PEST COMPLEX. WHITEFLY CONTROL CRITICAL. ",
    "index": "132",
    "hi": {
      "name": "जरबेरा",
      "pest": "सफेद मक्खी, थ्रिप्स, पत्ती सुरंगक, माइट"
    },
    "gu": {
      "name": "જર્બેરા",
      "pest": "સફેદમાખી, થ્રિપ્સ, પાન કોરિયું, કથીરી"
    }
  },
  {
    "name": "CARNATION",
    "category": "FLOWER",
    "pest": "RED SPIDER MITE, THRIPS, BUD BORER",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "KARNATAKA, HP",
    "details": "MITES CAUSE WEBBING. ",
    "index": "133",
    "hi": {
      "name": "कार्नेशन",
      "pest": "लाल मकड़ी माइट, थ्रिप्स, कली छेदक"
    },
    "gu": {
      "name": "કાર્નેશન",
      "pest": "લાલ કરોળિયા કથીરી, થ્રિપ્સ, કળી ભેદક"
    }
  },
  {
    "name": "ORCHID",
    "category": "FLOWER",
    "pest": "MITES, THRIPS, SCALE, SNAIL",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "KERALA, NE INDIA",
    "details": "SHOOT BORER (PERIDAEDALA) ALSO RECORDED. ",
    "index": "134",
    "hi": {
      "name": "ऑर्किड",
      "pest": "माइट, थ्रिप्स, स्केल कीट, घोंघा"
    },
    "gu": {
      "name": "ઓર્કિડ",
      "pest": "કથીરી, થ્રિપ્સ, ચીકટો, ગોકળગાય"
    }
  },
  {
    "name": "LILY",
    "category": "FLOWER",
    "pest": "LILY CATERPILLAR, APHIDS",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "TN, KARNATAKA",
    "details": "POLYTELA GLORIOSAE FEEDS ON LEAVES. ",
    "index": "135",
    "hi": {
      "name": "लिली",
      "pest": "लिली इल्ली, माहू"
    },
    "gu": {
      "name": "લિલી",
      "pest": "લિલી ઈયળ, મોલો"
    }
  },
  {
    "name": "ANTHURIUM",
    "category": "FLOWER",
    "pest": "THRIPS, MITES, SCALE, APHIDS",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "KERALA, KARNATAKA",
    "details": "THRIPS CAUSE STREAK DAMAGE. ",
    "index": "136",
    "hi": {
      "name": "एन्थूरियम",
      "pest": "थ्रिप्स, माइट, स्केल कीट, माहू"
    },
    "gu": {
      "name": "એન્થુરિયમ",
      "pest": "થ્રિપ્સ, કથીરી, ચીકટો, મોલો"
    }
  },
  {
    "name": "PETUNIA",
    "category": "FLOWER",
    "pest": "BUDWORM, APHIDS",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "GARDENS ACROSS INDIA",
    "details": "HELICOVERPA FEEDS ON FLOWERS. ",
    "index": "137",
    "hi": {
      "name": "पिटूनिया",
      "pest": "कली इल्ली, माहू"
    },
    "gu": {
      "name": "પિટુનિયા",
      "pest": "કળી ઈયળ, મોલો"
    }
  },
  {
    "name": "DAHLIA",
    "category": "FLOWER",
    "pest": "APHIDS, THRIPS, LEAF HOPPER",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "WB, KARNATAKA",
    "details": "SUCKING PESTS DAMAGE BLOOMS. ",
    "index": "138",
    "hi": {
      "name": "डहेलिया",
      "pest": "माहू, थ्रिप्स, पत्ती फुदका"
    },
    "gu": {
      "name": "ડેલિયા",
      "pest": "મોલો, થ્રિપ્સ, પાન તડતડિયો"
    }
  },
  {
    "name": "SUNFLOWER (ORN)",
    "category": "FLOWER",
    "pest": "HEAD BORER, JASSIDS",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "KARNATAKA, MAHARASHTRA",
    "details": "HELICOVERPA ATTACKS HEADS. ",
    "index": "139",
    "hi": {
      "name": "सूरजमुखी",
      "pest": "शीर्ष छेदक, हरा तेला"
    },
    "gu": {
      "name": "સૂરજમુખી",
      "pest": "ડૂંડા ભેદક, તડતડિયાં"
    }
  },
  {
    "name": "LAVENDER",
    "category": "FLOWER",
    "pest": "SPITTLE BUG, APHIDS",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "J&K",
    "details": "MINOR PESTS. ",
    "index": "140",
    "hi": {
      "name": "लैवेंडर",
      "pest": "स्पिटल बग, माहू"
    },
    "gu": {
      "name": "લવેન્ડર",
      "pest": "સ્પિટલ બગ, મોલો"
    }
  },
  {
    "name": "TULIP",
    "category": "FLOWER",
    "pest": "APHIDS, BULB MITE",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "J&K",
    "details": "APHIDS VECTOR VIRUSES. ",
    "index": "141",
    "hi": {
      "name": "ट्यूलिप",
      "pest": "माहू, कंद माइट"
    },
    "gu": {
      "name": "ટ્યૂલિપ",
      "pest": "મોલો, કંદ કથીરી"
    }
  },
  {
    "name": "PANSY",
    "category": "FLOWER",
    "pest": "APHIDS, SLUGS",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "NORTHERN INDIA",
    "details": "APHIDS CLUSTER ON STEMS. ",
    "index": "142",
    "hi": {
      "name": "पैंसी",
      "pest": "माहू, स्लग"
    },
    "gu": {
      "name": "પેન્સી",
      "pest": "મોલો, ગોકળગાય"
    }
  },
  {
    "name": "ZINNIA",
    "category": "FLOWER",
    "pest": "LEAF MINER, JAPANESE BEETLE",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "GARDENS ACROSS INDIA",
    "details": "GENERALIST PESTS. ",
    "index": "143",
    "hi": {
      "name": "ज़िनिया",
      "pest": "पत्ती सुरंगक, जापानी भृंग"
    },
    "gu": {
      "name": "ઝિનિયા",
      "pest": "પાન કોરિયું, જાપાની ભમરો"
    }
  },
  {
    "name": "ASTER",
    "category": "FLOWER",
    "pest": "LEAF HOPPER, APHIDS",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "KARNATAKA",
    "details": "HOPPERS TRANSMIT ASTER YELLOWS. ",
    "index": "144",
    "hi": {
      "name": "एस्टर",
      "pest": "पत्ती फुदका, माहू"
    },
    "gu": {
      "name": "એસ્ટર",
      "pest": "પાન તડતડિયો, મોલો"
    }
  },
  {
    "name": "IXORA",
    "category": "FLOWER",
    "pest": "SCALE, MEALYBUG",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "SOUTH INDIA",
    "details": "SUCKING PESTS CAUSE SOOTY MOLD. ",
    "index": "145",
    "hi": {
      "name": "इक्सोरा",
      "pest": "स्केल कीट, मिलीबग"
    },
    "gu": {
      "name": "ઇક્સોરા",
      "pest": "ચીકટો, મિલીબગ"
    }
  },
  {
    "name": "HIBISCUS",
    "category": "FLOWER",
    "pest": "MEALYBUG, APHIDS, BUD BORER",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "ALL INDIA",
    "details": "MACONELLICOCCUS (PINK MEALYBUG) CAUSES BUNCHY TOP. ",
    "index": "146",
    "hi": {
      "name": "गुड़हल",
      "pest": "मिलीबग, माहू, कली छेदक"
    },
    "gu": {
      "name": "જાસૂદ",
      "pest": "મિલીબગ, મોલો, કળી ભેદક"
    }
  },
  {
    "name": "TURMERIC",
    "category": "SPICE",
    "pest": "SHOOT BORER, RHIZOME SCALE, LACE WING BUG",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "AP, TN, ODISHA",
    "details": "CONOGETHES CAUSES DEAD HEARTS. MOTHS ACTIVE NIGHT. ",
    "index": "147",
    "hi": {
      "name": "हल्दी",
      "pest": "प्ररोह छेदक, प्रकंद स्केल, लेस विंग बग"
    },
    "gu": {
      "name": "હળદર",
      "pest": "ડૂંખ ભેદક, ગાંઠ ચીકટો, લેસ વિંગ બગ"
    }
  },
  {
    "name": "GINGER",
    "category": "SPICE",
    "pest": "SHOOT BORER, RHIZOME SCALE",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "KERALA, KARNATAKA, NE",
    "details": "SAME BORER AS TURMERIC. ",
    "index": "148",
    "hi": {
      "name": "अदरक",
      "pest": "प्ररोह छेदक, प्रकंद स्केल"
    },
    "gu": {
      "name": "આદુ",
      "pest": "ડૂંખ ભેદક, ગાંઠ ચીકટો"
    }
  },
  {
    "name": "BLACK PEPPER",
    "category": "SPICE",
    "pest": "POLLU BEETLE, TOP SHOOT BORER, SCALE",
    "on": "7:30 PM",
    "off": "10:30 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "KERALA, KARNATAKA",
    "details": "LONGITARSUS (POLLU BEETLE) HOLLOWS BERRIES. ACTIVE DUSK. ",
    "index": "149",
    "hi": {
      "name": "काली मिर्च",
      "pest": "पोल्लू भृंग, शीर्ष प्ररोह छेदक, स्केल कीट"
    },
    "gu": {
      "name": "કાળા મરી",
      "pest": "પોલ્લુ ભમરો, ટોચ ડૂંખ ભેદક, ચીકટો"
    }
  },
  {
    "name": "WHITE PEPPER",
    "category": "SPICE",
    "pest": "POLLU BEETLE",
    "on": "7:30 PM",
    "off": "10:30 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "KERALA",
    "details": "PROCESSED PEPPER; FIELD PEST SAME.",
    "index": "150",
    "hi": {
      "name": "सफेद मिर्च",
      "pest": "पोल्लू भृंग"
    },
    "gu": {
      "name": "સફેદ મરી",
      "pest": "પોલ્લુ ભમરો"
    }
  },
  {
    "name": "CARDAMOM",
    "category": "SPICE",
    "pest": "THRIPS, SHOOT/CAPSULE BORER, WHITEFLY",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "KERALA, KARNATAKA, TN",
    "details": "SCIOTHRIPS DAMAGES CAPSULES. CONOGETHES BORES SHOOTS. ",
    "index": "151",
    "hi": {
      "name": "इलायची",
      "pest": "थ्रिप्स, प्ररोह/कैप्सूल छेदक, सफेद मक्खी"
    },
    "gu": {
      "name": "એલચી",
      "pest": "થ્રિપ્સ, ડૂંખ/બોંડ ભેદક, સફેદમાખી"
    }
  },
  {
    "name": "CLOVE",
    "category": "SPICE",
    "pest": "STEM BORER, SCALE, MEALYBUG",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "TN, KERALA",
    "details": "SAHYADRASSUS BORES STEM. ",
    "index": "152",
    "hi": {
      "name": "लौंग",
      "pest": "तना छेदक, स्केल कीट, मिलीबग"
    },
    "gu": {
      "name": "લવિંગ",
      "pest": "થડ ભેદક, ચીકટો, મિલીબગ"
    }
  },
  {
    "name": "CINNAMON",
    "category": "SPICE",
    "pest": "CINNAMON BUTTERFLY, LEAF MINER",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "KERALA, SOUTH INDIA",
    "details": "PAPILIO LARVAE FEED ON LEAVES. ",
    "index": "153",
    "hi": {
      "name": "दालचीनी",
      "pest": "दालचीनी तितली, पत्ती सुरंगक"
    },
    "gu": {
      "name": "તજ",
      "pest": "તજ પતંગિયું, પાન કોરિયું"
    }
  },
  {
    "name": "NUTMEG",
    "category": "SPICE",
    "pest": "FRUIT BORER, SCALE",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "KERALA, TN",
    "details": "ANONAEPESTIS BORES FRUIT. ",
    "index": "154",
    "hi": {
      "name": "जायफल",
      "pest": "फल छेदक, स्केल कीट"
    },
    "gu": {
      "name": "જાયફળ",
      "pest": "ફળ ભેદક, ચીકટો"
    }
  },
  {
    "name": "MACE",
    "category": "SPICE",
    "pest": "FRUIT BORER",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "KERALA",
    "details": "PART OF NUTMEG. ",
    "index": "155",
    "hi": {
      "name": "जावित्री",
      "pest": "फल छेदक"
    },
    "gu": {
      "name": "જાવંત્રી",
      "pest": "ફળ ભેદક"
    }
  },
  {
    "name": "CORIANDER",
    "category": "SPICE",
    "pest": "APHIDS, INDARBELA (STEM BORER)",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "RAJASTHAN, GUJARAT, MP",
    "details": "APHIDS RUIN SEED. ",
    "index": "156",
    "hi": {
      "name": "धनिया",
      "pest": "माहू, इंदरबेला (तना छेदक)"
    },
    "gu": {
      "name": "ધાણા",
      "pest": "મોલો, ઇન્દરબેલા (થડ ભેદક)"
    }
  },
  {
    "name": "CUMIN",
    "category": "SPICE",
    "pest": "APHIDS, THRIPS",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "GUJARAT, RAJASTHAN",
    "details": "APHIDS MAJOR REDUCER. ",
    "index": "157",
    "hi": {
      "name": "जीरा",
      "pest": "माहू, थ्रिप्स"
    },
    "gu": {
      "name": "જીરું",
      "pest": "મોલો, થ્રિપ્સ"
    }
  },
  {
    "name": "FENNEL",
    "category": "SPICE",
    "pest": "APHIDS, SEED WASP",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "GUJARAT, RAJASTHAN",
    "details": "APHIDS ATTACK UMBELS. ",
    "index": "158",
    "hi": {
      "name": "सौंफ",
      "pest": "माहू, बीज ततैया"
    },
    "gu": {
      "name": "વરિયાળી",
      "pest": "મોલો, બીજ ભમરી"
    }
  },
  {
    "name": "FENUGREEK",
    "category": "SPICE",
    "pest": "APHIDS, LEAF MINER",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "RAJASTHAN, GUJARAT",
    "details": "APHID INFESTATIONS COMMON. ",
    "index": "159",
    "hi": {
      "name": "मेथी",
      "pest": "माहू, पत्ती सुरंगक"
    },
    "gu": {
      "name": "મેથી",
      "pest": "મોલો, પાન કોરિયું"
    }
  },
  {
    "name": "MUSTARD SEED",
    "category": "SPICE",
    "pest": "APHIDS, PAINTED BUG",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "RAJASTHAN, HARYANA",
    "details": "SAME AS CROP. ",
    "index": "160",
    "hi": {
      "name": "सरसों",
      "pest": "माहू, चित्रित बग"
    },
    "gu": {
      "name": "રાઈ",
      "pest": "મોલો, ચિતરેલ બગ"
    }
  },
  {
    "name": "STAR ANISE",
    "category": "SPICE",
    "pest": "SCALE",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "ARUNACHAL PRADESH",
    "details": "ILLICIUM PEST UNKNOWN, POSSIBLY SCALE. ",
    "index": "161",
    "hi": {
      "name": "चक्र फूल",
      "pest": "स्केल कीट"
    },
    "gu": {
      "name": "બાદિયાન",
      "pest": "ચીકટો"
    }
  },
  {
    "name": "BAY LEAF",
    "category": "SPICE",
    "pest": "LEAF WEBBER, APHIDS",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "NE INDIA",
    "details": "ORTHAGA WEBS LEAVES. ",
    "index": "162",
    "hi": {
      "name": "तेजपत्ता",
      "pest": "पत्ती जालक, माहू"
    },
    "gu": {
      "name": "તમાલપત્ર",
      "pest": "પાન જાળિયું, મોલો"
    }
  },
  {
    "name": "TAMARIND",
    "category": "SPICE",
    "pest": "FRUIT BORER, MEALYBUG, SCALE",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "TN, KARNATAKA, AP",
    "details": "APHOMIA ATTACKS PODS. ",
    "index": "163",
    "hi": {
      "name": "इमली",
      "pest": "फल छेदक, मिलीबग, स्केल कीट"
    },
    "gu": {
      "name": "આમલી",
      "pest": "ફળ ભેદક, મિલીબગ, ચીકટો"
    }
  },
  {
    "name": "VANILLA",
    "category": "SPICE",
    "pest": "VANILLA BUG, WHITE GRUB, SHOOT WEBBER",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "KERALA, KARNATAKA",
    "details": "HALYOMORPHA DAMAGES BEANS. GRUBS ROOTS. ",
    "index": "164",
    "hi": {
      "name": "वनीला",
      "pest": "वनीला बग, सफेद गिडार, प्ररोह जालक"
    },
    "gu": {
      "name": "વેનીલા",
      "pest": "વેનીલા બગ, ધૈણ, ડૂંખ જાળિયું"
    }
  },
  {
    "name": "TEA",
    "category": "PLANTATION",
    "pest": "TEA MOSQUITO BUG, RED SPIDER MITE, THRIPS, LOOPER",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "ASSAM, WB, TN, KERALA",
    "details": "HELOPELTIS ACTIVE EARLY/LATE. BUZURA LOOPER NOCTURNAL. ",
    "index": "165",
    "hi": {
      "name": "चाय",
      "pest": "चाय मच्छर बग, लाल मकड़ी माइट, थ्रिप्स, लूपर"
    },
    "gu": {
      "name": "ચા",
      "pest": "ચા મચ્છર બગ, લાલ કરોળિયા કથીરી, થ્રિપ્સ, લૂપર"
    }
  },
  {
    "name": "COFFEE",
    "category": "PLANTATION",
    "pest": "COFFEE BERRY BORER, WHITE STEM BORER, GREEN SCALE",
    "on": "3:00 PM",
    "off": "7:00 PM",
    "duration": "4:00",
    "light": "WARM",
    "region": "KARNATAKA, KERALA",
    "details": "HYPOTHENEMUS FEMALES FLY AFTERNOON. XYLOTRECHUS SUNNY DAYS. ",
    "index": "166",
    "hi": {
      "name": "कॉफी",
      "pest": "कॉफी बेरी छेदक, सफेद तना छेदक, हरा स्केल"
    },
    "gu": {
      "name": "કોફી",
      "pest": "કોફી બેરી ભેદક, સફેદ થડ ભેદક, લીલી ચીકટો"
    }
  },
  {
    "name": "RUBBER",
    "category": "PLANTATION",
    "pest": "SCALE, MEALYBUG, BARK CATERPILLAR",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "KERALA, TN",
    "details": "AETHERASTIS MOTHS ACTIVE NIGHT. ",
    "index": "167",
    "hi": {
      "name": "रबर",
      "pest": "स्केल कीट, मिलीबग, छाल इल्ली"
    },
    "gu": {
      "name": "રબર",
      "pest": "ચીકટો, મિલીબગ, છાલ ઈયળ"
    }
  },
  {
    "name": "COCOA",
    "category": "PLANTATION",
    "pest": "TEA MOSQUITO BUG, MEALYBUG, POD BORER",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "KERALA, KARNATAKA",
    "details": "HELOPELTIS & CONOGETHES. ",
    "index": "168",
    "hi": {
      "name": "कोको",
      "pest": "चाय मच्छर बग, मिलीबग, फली छेदक"
    },
    "gu": {
      "name": "કોકો",
      "pest": "ચા મચ્છર બગ, મિલીબગ, શીંગ ભેદક"
    }
  },
  {
    "name": "COTTON",
    "category": "FIBRE",
    "pest": "PINK BOLLWORM, AMERICAN BOLLWORM, SPOTTED BOLLWORM, WHITEFLY, JASSIDS",
    "on": "7:00 PM",
    "off": "11:00 PM",
    "duration": "4:00",
    "light": "UV",
    "region": "MAHARASHTRA, GUJARAT, PUNJAB, TELANGANA",
    "details": "PECTINOPHORA (PBW) & HELICOVERPA NOCTURNAL. PBW MATING LATE NIGHT. SUCKING PESTS YELLOW TRAPS. ",
    "index": "169",
    "hi": {
      "name": "कपास",
      "pest": "गुलाबी सुंडी, अमेरिकन सुंडी, चित्तीदार सुंडी, सफेद मक्खी, हरा तेला"
    },
    "gu": {
      "name": "કપાસ",
      "pest": "ગુલાબી ઈયળ, અમેરિકન ઈયળ, ટપકાંવાળી ઈયળ, સફેદમાખી, તડતડિયાં"
    }
  },
  {
    "name": "JUTE",
    "category": "FIBRE",
    "pest": "JUTE SEMILOOPER, HAIRY CATERPILLAR, STEM WEEVIL",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "WB, BIHAR, ASSAM",
    "details": "ANOMIS SEMILOOPER & SPILOSOMA DEFOLIATORS. MOTHS LIGHT-ATTRACTED. ",
    "index": "170",
    "hi": {
      "name": "जूट",
      "pest": "जूट सेमीलूपर, रोमिल इल्ली, तना घुन"
    },
    "gu": {
      "name": "શણ",
      "pest": "જ્યુટ સેમિલૂપર, રુવાંટીવાળી ઈયળ, થડ ઘૈણ"
    }
  },
  {
    "name": "KENAF",
    "category": "FIBRE",
    "pest": "FLEA BEETLE, AGRILUS BORER",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "AP, WB",
    "details": "PODAGRICA MAKES SHOT HOLES. ",
    "index": "171",
    "hi": {
      "name": "केनाफ",
      "pest": "पिस्सू भृंग, एग्रिलस छेदक"
    },
    "gu": {
      "name": "અંબાડી",
      "pest": "ચાંચડ ભમરો, એગ્રિલસ ભેદક"
    }
  },
  {
    "name": "HEMP",
    "category": "FIBRE",
    "pest": "CANNABIS APHID, CORN BORER",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "UTTARAKHAND",
    "details": "OSTRINIA CAN BORE STEMS. ",
    "index": "172",
    "hi": {
      "name": "भांग",
      "pest": "भांग माहू, मक्का छेदक"
    },
    "gu": {
      "name": "શણ",
      "pest": "શણ મોલો, મકાઈ ભેદક"
    }
  },
  {
    "name": "SISAL",
    "category": "FIBRE",
    "pest": "SISAL WEEVIL",
    "on": "7:30 PM",
    "off": "10:30 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "ODISHA, MAHARASHTRA",
    "details": "SCYPHOPHORUS WEEVIL. ",
    "index": "173",
    "hi": {
      "name": "सिसल",
      "pest": "सिसल घुन"
    },
    "gu": {
      "name": "સીસલ",
      "pest": "સીસલ ઘૈણ"
    }
  },
  {
    "name": "ALOE VERA",
    "category": "MEDICINAL",
    "pest": "MEALYBUG, APHIDS",
    "on": "6:00 PM",
    "off": "9:00 PM",
    "duration": "3:00",
    "light": "WARM",
    "region": "RAJASTHAN, GUJARAT",
    "details": "SUCKING PESTS. ",
    "index": "174",
    "hi": {
      "name": "एलोवेरा",
      "pest": "मिलीबग, माहू"
    },
    "gu": {
      "name": "એલોવેરા",
      "pest": "મિલીબગ, મોલો"
    }
  },
  {
    "name": "ASHWAGANDHA",
    "category": "MEDICINAL",
    "pest": "HADDA BEETLE, APHIDS",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "MP, RAJASTHAN",
    "details": "EPILACHNA BEETLES FEED ON LEAVES. ",
    "index": "175",
    "hi": {
      "name": "अश्वगंधा",
      "pest": "हड्डा भृंग, माहू"
    },
    "gu": {
      "name": "અશ્વગંધા",
      "pest": "હડ્ડા ભમરો, મોલો"
    }
  },
  {
    "name": "TULSI",
    "category": "MEDICINAL",
    "pest": "LACE WING BUG, LEAF ROLLER",
    "on": "6:30 PM",
    "off": "10:00 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "ACROSS INDIA",
    "details": "COCHLOCHILA CAUSES WILTING. SYNGAMIA ROLLS LEAVES. ",
    "index": "176",
    "hi": {
      "name": "तुलसी",
      "pest": "लेस विंग बग, पत्ती लपेटक"
    },
    "gu": {
      "name": "તુલસી",
      "pest": "લેસ વિંગ બગ, પાન વાળનાર"
    }
  },
  {
    "name": "ISABGOL",
    "category": "MEDICINAL",
    "pest": "APHIDS, WHITE GRUB",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "GUJARAT, RAJASTHAN",
    "details": "APHIS GOSSYPII MAJOR PEST. ",
    "index": "177",
    "hi": {
      "name": "इसबगोल",
      "pest": "माहू, सफेद गिडार"
    },
    "gu": {
      "name": "ઇસબગુલ",
      "pest": "મોલો, ધૈણ"
    }
  },
  {
    "name": "BRAHMI",
    "category": "MEDICINAL",
    "pest": "LEAF WEBBER, GRASSHOPPERS",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "WETLANDS",
    "details": "SYNGAMIA WEBS LEAVES. ",
    "index": "178",
    "hi": {
      "name": "ब्राह्मी",
      "pest": "पत्ती जालक, टिड्डे"
    },
    "gu": {
      "name": "બ્રાહ્મી",
      "pest": "પાન જાળિયું, તીડ"
    }
  },
  {
    "name": "SHATAVARI",
    "category": "MEDICINAL",
    "pest": "ASPARAGUS BEETLE",
    "on": "7:00 PM",
    "off": "10:00 PM",
    "duration": "3:00",
    "light": "UV",
    "region": "ACROSS INDIA",
    "details": "LEMA DOWNESI FEEDS CLADODES. ",
    "index": "179",
    "hi": {
      "name": "शतावरी",
      "pest": "शतावरी भृंग"
    },
    "gu": {
      "name": "શતાવરી",
      "pest": "શતાવરી ભમરો"
    }
  },
  {
    "name": "VETIVER",
    "category": "MEDICINAL",
    "pest": "TERMITES, WHITE GRUB",
    "on": "7:30 PM",
    "off": "11:00 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "SOUTH INDIA, COASTAL",
    "details": "TERMITES SWARM AT NIGHT. ",
    "index": "180",
    "hi": {
      "name": "खस",
      "pest": "दीमक, सफेद गिडार"
    },
    "gu": {
      "name": "વેટીવર",
      "pest": "ઉધઈ, ધૈણ"
    }
  },
  {
    "name": "LEMONGRASS",
    "category": "MEDICINAL",
    "pest": "STEM BORER, TERMITES",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "KERALA, MAHARASHTRA",
    "details": "CHILO SPP. BORE STEMS. ",
    "index": "181",
    "hi": {
      "name": "लेमनग्रास",
      "pest": "तना छेदक, दीमक"
    },
    "gu": {
      "name": "લેમનગ્રાસ",
      "pest": "થડ ભેદક, ઉધઈ"
    }
  },
  {
    "name": "CITRONELLA",
    "category": "MEDICINAL",
    "pest": "STEM BORER, TERMITES",
    "on": "7:00 PM",
    "off": "10:30 PM",
    "duration": "3:30",
    "light": "UV",
    "region": "NE INDIA, SOUTH INDIA",
    "details": "SIMILAR TO LEMONGRASS. ",
    "index": "182",
    "hi": {
      "name": "सिट्रोनेला",
      "pest": "तना छेदक, दीमक"
    },
    "gu": {
      "name": "સિટ્રોનેલા",
      "pest": "થડ ભેદક, ઉધઈ"
    }
  },
  {
    "name": "PALMAROSA",
    "category": "MEDICINAL",
    "pest": "THRIPS, WHITE GRUB",
    "on": "6:00 PM",
    "off": "9:30 PM",
    "duration": "3:30",
    "light": "WARM",
    "region": "MAHARASHTRA, MP",
    "details": "THRIPS DAMAGE INFLORESCENCE. ",
    "index": "183",
    "hi": {
      "name": "पामारोसा",
      "pest": "थ्रिप्स, सफेद गिडार"
    },
    "gu": {
      "name": "પામારોસા",
      "pest": "થ્રિપ્સ, ધૈણ"
    }
  }
];

export default cropData;
